import { Implements, Service, ServiceLifetime, collection, createFactoryDescriptor, createInterfaceId } from "@gitlab/needle";
import { treeifyError, z } from "zod";
import { Result, ResultAsync, err, errAsync, ok, okAsync } from "neverthrow";
import { Logger, withPrefix } from "@gitlab-org/logging";
import { PersistentStorage } from "@gitlab-org/persistent-storage";
import EventEmitter$1, { EventEmitter } from "events";
import * as fs from "fs/promises";
import * as path$1 from "path";
import path from "path";
import { parseJSONC, stringifyJSON } from "confbox";
import crypto, { createHash } from "crypto";
import { homedir } from "node:os";
import { UnauthorizedError } from "@modelcontextprotocol/sdk/client/auth.js";
import { CompositeDisposable } from "@gitlab-org/disposable";
import { ToolListChangedNotificationSchema } from "@modelcontextprotocol/sdk/types.js";
import { Client } from "@modelcontextprotocol/sdk/client/index.js";
import Fastify from "fastify";
import FastifyRateLimit from "@fastify/rate-limit";
import { StreamableHTTPClientTransport } from "@modelcontextprotocol/sdk/client/streamableHttp.js";
import { SSEClientTransport } from "@modelcontextprotocol/sdk/client/sse.js";
import { StdioClientTransport } from "@modelcontextprotocol/sdk/client/stdio.js";
import { LsFetch } from "@gitlab-org/fetch";
//#region src/mcp/approval/session/types.ts
const McpToolSessionApprovalStore = createInterfaceId("McpToolSessionApprovalStore");
//#endregion
//#region src/mcp/approval/session/in_memory_session_approval_store.ts
let _initClass$14;
function _applyDecs$14(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$14(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$14(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$14(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$14(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$14(t) {
	var i = _toPrimitive$14(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$14(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$14(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$14(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _InMemoryMcpToolSessi;
(class {
	static {
		[_InMemoryMcpToolSessi, _initClass$14] = _applyDecs$14(this, [Implements(McpToolSessionApprovalStore), Service({
			dependencies: [],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#approvals = /* @__PURE__ */ new Map();
	async approveTool(workflowId, address) {
		const serverMap = this.#ensureWorkflow(workflowId);
		this.#ensureServer(serverMap, address.serverName).add(address.toolName);
	}
	async revokeTool(workflowId, { serverName, toolName }) {
		const serverMap = this.#approvals.get(workflowId);
		if (!serverMap) return;
		const toolSet = serverMap.get(serverName);
		if (!toolSet) return;
		toolSet.delete(toolName);
		if (toolSet.size === 0) {
			serverMap.delete(serverName);
			if (serverMap.size === 0) this.#approvals.delete(workflowId);
		}
	}
	async revokeToolsForWorkflow(workflowId) {
		this.#approvals.delete(workflowId);
	}
	async revokeToolsForServer(serverName) {
		for (const [workflowId, serverMap] of this.#approvals) if (serverMap.has(serverName)) {
			serverMap.delete(serverName);
			if (serverMap.size === 0) this.#approvals.delete(workflowId);
		}
	}
	async revokeToolsForServerInWorkflow(workflowId, server) {
		const serverMap = this.#approvals.get(workflowId);
		if (!serverMap) return;
		serverMap.delete(server);
		if (serverMap.size === 0) this.#approvals.delete(workflowId);
	}
	isToolApproved(workflowId, address) {
		return Boolean(this.#approvals.get(workflowId)?.get(address.serverName)?.has(address.toolName));
	}
	#ensureWorkflow(workflowId) {
		let serverMap = this.#approvals.get(workflowId);
		if (!serverMap) {
			serverMap = /* @__PURE__ */ new Map();
			this.#approvals.set(workflowId, serverMap);
		}
		return serverMap;
	}
	#ensureServer(serverMap, serverName) {
		let toolSet = serverMap.get(serverName);
		if (!toolSet) {
			toolSet = /* @__PURE__ */ new Set();
			serverMap.set(serverName, toolSet);
		}
		return toolSet;
	}
	static {
		_initClass$14();
	}
});
//#endregion
//#region src/mcp/types/mcp.ts
const ServerName = z.string().min(1).max(250).regex(/^[a-zA-Z0-9_.-]+$/).refine((val) => !/\s/.test(val)).transform((x) => x);
/**
* Tool information with approval state
*/
/**
* Server state with connection and metadata information
*/
/**
* Log levels for MCP server logs
*/
let LogLevel = /* @__PURE__ */ function(LogLevel) {
	LogLevel["Debug"] = "debug";
	LogLevel["Info"] = "info";
	LogLevel["Warning"] = "warning";
	LogLevel["Error"] = "error";
	return LogLevel;
}({});
/**
* ⚠️ WARNING: If MCP_PREFIX changes, you must also change the MCP_PATTERN
*/
const MCP_PREFIX = "mcp";
const MCP_PATTERN = /^mcp__(.*?)__(.*)$/;
const McpToolName = {
	/** Create canonical tool name from its address */
	create: (address) => {
		return [
			MCP_PREFIX,
			address.serverName,
			address.toolName
		].join("__");
	},
	/** Parse canonical tool name back into its address */
	parse(input) {
		return parse(input).match((address) => address, (error) => {
			throw error;
		});
	},
	/** Type guard for strings that look like a canonical tool name */
	is(value) {
		return parse(value).isOk();
	}
};
function parse(input) {
	const match = input.match(MCP_PATTERN);
	if (!match) {
		const EXAMPLE = McpToolName.create({
			serverName: "serverName",
			toolName: "toolName"
		});
		return err(/* @__PURE__ */ new Error(`Invalid MCP tool name: "${input}". Expected format: ${EXAMPLE}`));
	}
	const [, rawServerName, toolName] = match;
	if (!rawServerName || !toolName) return err(/* @__PURE__ */ new Error(`Invalid MCP tool name: "${input}". Server name or tool name is empty.`));
	return Result.fromThrowable(() => ServerName.parse(rawServerName), (error) => /* @__PURE__ */ new Error(`Invalid server name "${rawServerName}" in MCP tool name: ${error}`))().map((serverName) => ({
		serverName,
		toolName
	}));
}
//#endregion
//#region src/mcp/approval/types.ts
const McpToolApprovalController = createInterfaceId("McpToolApprovalController");
//#endregion
//#region src/mcp/approval/default_mcp_tool_approval_controller.ts
let _initClass$13;
function _applyDecs$13(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$13(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$13(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$13(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$13(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$13(t) {
	var i = _toPrimitive$13(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$13(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$13(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$13(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _DefaultMcpToolApprov;
(class {
	static {
		[_DefaultMcpToolApprov, _initClass$13] = _applyDecs$13(this, [Implements(McpToolApprovalController), Service({
			dependencies: [McpToolSessionApprovalStore],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#store;
	constructor(store) {
		this.#store = store;
	}
	async approveToolForSession(workflowId, toolName) {
		const address = McpToolName.parse(toolName);
		await this.#store.approveTool(workflowId, address);
	}
	static {
		_initClass$13();
	}
});
//#endregion
//#region src/mcp/approval/server/types.ts
const McpServerApprovalStore = createInterfaceId("McpServerApprovalStore");
//#endregion
//#region src/mcp/approval/server/persistent_server_approval_store.ts
let _initClass$12;
function _applyDecs$12(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$12(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$12(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$12(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$12(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$12(t) {
	var i = _toPrimitive$12(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$12(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$12(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$12(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const STORAGE_KEY = "mcpApprovals";
const SCHEMA_VERSION = 1;
function isValidSchema(raw) {
	return typeof raw === "object" && raw !== null && "version" in raw && typeof raw.version === "number" && "approvals" in raw && typeof raw.approvals === "object" && raw.approvals !== null;
}
let _PersistentMcpServerA;
(class {
	static {
		[_PersistentMcpServerA, _initClass$12] = _applyDecs$12(this, [Implements(McpServerApprovalStore), Service({
			dependencies: [Logger, PersistentStorage],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#logger;
	#storage;
	#queue = Promise.resolve();
	constructor(logger, storage) {
		this.#logger = withPrefix(logger, "[MCP][ServerApprovalStore]");
		this.#storage = storage;
	}
	/** Run `operation` after all previously-enqueued operations have settled. */
	#enqueue(operation) {
		const result = this.#queue.then(operation, operation);
		this.#queue = result.then(() => void 0, () => void 0);
		return result;
	}
	async lookup(configHash) {
		return this.#enqueue(async () => {
			try {
				return (await this.#readSchema()).approvals[configHash];
			} catch (error) {
				this.#logger.error(`Failed to look up approval for hash ${configHash}`, error);
				return;
			}
		});
	}
	async approve(configHash) {
		await this.#enqueue(() => this.#upsert(configHash, "approved"));
	}
	async reject(configHash) {
		await this.#enqueue(() => this.#upsert(configHash, "rejected"));
	}
	async revoke(configHash) {
		await this.#enqueue(async () => {
			try {
				const schema = await this.#readSchema();
				if (!(configHash in schema.approvals)) return;
				delete schema.approvals[configHash];
				await this.#writeSchema(schema);
				this.#logger.info(`Revoked approval for hash ${configHash}`);
			} catch (error) {
				this.#logger.error(`Failed to revoke approval for hash ${configHash}`, error);
				throw error;
			}
		});
	}
	async list() {
		return this.#enqueue(async () => {
			try {
				const schema = await this.#readSchema();
				return Object.entries(schema.approvals).map(([hash, entry]) => ({
					hash,
					...entry
				}));
			} catch (error) {
				this.#logger.error("Failed to list approvals", error);
				return [];
			}
		});
	}
	async #readSchema() {
		const raw = await this.#storage.get(STORAGE_KEY);
		if (raw === void 0 || raw === null) return {
			version: SCHEMA_VERSION,
			approvals: {}
		};
		if (!isValidSchema(raw)) {
			this.#logger.warn(`Unexpected mcpApprovals schema — resetting. Raw: ${JSON.stringify(raw)}`);
			return {
				version: SCHEMA_VERSION,
				approvals: {}
			};
		}
		return raw;
	}
	async #writeSchema(schema) {
		await this.#storage.set(STORAGE_KEY, schema);
	}
	async #upsert(configHash, decision) {
		try {
			const schema = await this.#readSchema();
			const existing = schema.approvals[configHash];
			schema.approvals[configHash] = {
				...existing ?? {},
				decision
			};
			await this.#writeSchema(schema);
			this.#logger.info(`Recorded ${decision} for hash ${configHash.slice(0, 8)}…`);
		} catch (error) {
			this.#logger.error(`Failed to record ${decision} for hash ${configHash}`, error);
			throw error;
		}
	}
	static {
		_initClass$12();
	}
});
//#endregion
//#region src/mcp/approval/server/policy.ts
/**
* McpApprovalPolicy
*
* Determines the effective approval decision for a given MCP server config.
* The default implementation defers to the persisted store entry.
* The CLI registers AutoApproveApprovalPolicy in headless mode so that
* non-interactive runs are never blocked by the approval gate.
*/
const McpApprovalPolicy = createInterfaceId("McpApprovalPolicy");
//#endregion
//#region src/mcp/approval/server/default_approval_policy.ts
let _initClass$11;
function _applyDecs$11(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$11(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$11(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$11(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$11(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$11(t) {
	var i = _toPrimitive$11(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$11(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$11(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$11(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Default policy used by IDEs: returns the persisted decision, or
* 'pendingApproval' if no entry exists.
*/
let _DefaultApprovalPolic;
(class {
	static {
		[_DefaultApprovalPolic, _initClass$11] = _applyDecs$11(this, [Implements(McpApprovalPolicy), Service({
			dependencies: [],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	decide(_configHash, persistedEntry) {
		if (!persistedEntry) return "pendingApproval";
		return persistedEntry.decision;
	}
	static {
		_initClass$11();
	}
});
//#endregion
//#region src/mcp/approval/server/auto_approve_policy.ts
let _initClass$10;
function _applyDecs$10(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$10(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$10(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$10(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$10(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$10(t) {
	var i = _toPrimitive$10(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$10(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$10(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$10(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Auto-approve policy used by the CLI in headless mode.
* Always returns 'approved' without reading or writing the persistent store.
* This is intentional: headless runs cannot prompt the user, so they must
* be permissive. Auto-approval does NOT persist to storage.json.
*/
let _AutoApproveApprovalP;
(class {
	static {
		[_AutoApproveApprovalP, _initClass$10] = _applyDecs$10(this, [Implements(McpApprovalPolicy), Service({
			dependencies: [],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	decide() {
		return "approved";
	}
	static {
		_initClass$10();
	}
});
//#endregion
//#region src/mcp/approval/di.ts
function registerMcpApprovalServices(serviceCollection, approvalPolicyClass = _DefaultApprovalPolic) {
	serviceCollection.addClass(_InMemoryMcpToolSessi);
	serviceCollection.addClass(_DefaultMcpToolApprov);
	serviceCollection.addClass(_PersistentMcpServerA);
	serviceCollection.addClass(approvalPolicyClass);
}
//#endregion
//#region src/mcp/transport/stdio_command_transformer.ts
const McpStdioCommandTransformer = createInterfaceId("McpStdioCommandTransformer");
//#endregion
//#region src/mcp/config/types.ts
/**
* A single configuration file to load, together with the scope and expansion
* metadata that governs how its servers are treated after parsing.
*/
/**
* Result of parsing a single server configuration
*/
/**
* Successful resolution status for a single configuration file candidate.
*/
/**
* Failure status for a single configuration file candidate.
*/
/**
* Union of candidate statuses.
*/
/**
* Tracks where each final server configuration originated from and which
* candidates also defined it (for duplicate detection and diagnostics).
*/
/**
* Final result after loading and merging multiple configuration files.
*/
/**
* Service contract for loading, validating, and merging configuration files.
* Implementations must not throw; all failures are represented as results.
*/
const McpConfigResolver = createInterfaceId("McpConfigResolver");
//#endregion
//#region src/mcp/config/schema.ts
const NonEmptyString = z.string().min(1);
const Url = z.union([z.url().transform((x) => new URL(x)), z.instanceof(URL)]);
const OAuth2Config = z.object({
	clientId: z.string().optional(),
	clientSecret: z.string().optional(),
	scopes: z.array(z.string()).optional()
});
const BaseServerConfig = z.looseObject({ approvedTools: z.union([z.array(z.string()), z.boolean()]).optional() }).meta({ description: "Common MCP server fields" });
const McpSandboxOverrides = z.object({
	sandboxEnabled: z.boolean().optional(),
	allowedDomains: z.array(z.string()).optional(),
	allowWrite: z.array(z.string()).optional(),
	denyRead: z.array(z.string()).optional()
}).meta({ description: "Per-server sandbox overrides for sandbox provider" });
const StdioServerConfig = BaseServerConfig.extend({
	type: z.literal("stdio"),
	command: NonEmptyString,
	args: z.array(z.string()).optional(),
	cwd: z.string().optional(),
	env: z.record(z.string(), z.string()).optional(),
	sandbox: McpSandboxOverrides.optional()
});
const SseServerConfig = BaseServerConfig.extend({
	type: z.literal("sse"),
	url: Url,
	headers: z.record(z.string(), z.string()).optional(),
	oauth2: OAuth2Config.optional()
});
const StreamableHttpServerConfig = BaseServerConfig.extend({
	type: z.literal("http"),
	url: Url,
	headers: z.record(z.string(), z.string()).optional(),
	oauth2: OAuth2Config.optional()
});
const ServerConfig = z.discriminatedUnion("type", [
	StdioServerConfig,
	SseServerConfig,
	StreamableHttpServerConfig
]);
/**
* Basic configuration shape - ensures we have mcpServers object
* but doesn't validate individual server configs yet
*/
const BasicConfiguration = z.object({
	mcpServers: z.record(z.string(), z.unknown()),
	_managed: z.boolean().optional()
}).meta({ title: "Duo MCP config basic shape" });
z.object({
	mcpServers: z.record(ServerName, ServerConfig),
	_managed: z.boolean().optional()
}).meta({ title: "Duo MCP config root" });
//#endregion
//#region src/core/error.ts
const createError = (code, message, data) => ({
	code,
	message,
	...data,
	timestamp: (/* @__PURE__ */ new Date()).toISOString()
});
//#endregion
//#region src/mcp/config/errors.ts
/**
* Represents an error that occurred while attempting to read a configuration file from disk.
*/
/**
* Represents an error where the configuration file could not be found at the given path.
*/
/**
* Represents an error where the configuration file contains invalid JSON.
*/
/**
* Represents an error where the configuration file’s contents failed schema validation.
*/
/**
* Represents an error that occurred while attempting to write to a configuration file.
*/
/**
* Represents an error where a server was not found in the configuration file.
*/
/**
* Union of all configuration-related errors.
*/
/**
* Factory functions for creating configuration-related errors.
*/
const McpConfigurationError = {
	fileReadError: (filePath, cause) => createError("MCP_CONFIGURATION_FILE_READ_ERROR", `Failed to read configuration file: ${filePath}`, {
		filePath,
		cause
	}),
	fileNotFoundError: (filePath) => createError("MCP_CONFIGURATION_FILE_NOT_FOUND_ERROR", `Configuration file not found: ${filePath}`, { filePath }),
	fileJsonParseError: (filePath, cause) => createError("MCP_CONFIGURATION_FILE_JSON_PARSE_ERROR", `Invalid JSON in configuration file: ${filePath}`, {
		filePath,
		cause
	}),
	fileValidationError: (filePath, issues) => createError("MCP_CONFIGURATION_FILE_VALIDATION_ERROR", `Configuration validation failed: ${filePath}`, {
		filePath,
		issues
	}),
	fileWriteError: (filePath, cause) => createError("MCP_CONFIGURATION_FILE_WRITE_ERROR", `Failed to write configuration file: ${filePath}`, {
		filePath,
		cause
	}),
	serverNotFoundError: (filePath, serverName) => createError("MCP_CONFIGURATION_SERVER_NOT_FOUND_ERROR", `Server "${serverName}" not found in configuration file: ${filePath}`, {
		filePath,
		serverName
	})
};
//#endregion
//#region src/mcp/config/writer.ts
let _initClass$9;
function _applyDecs$9(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$9(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$9(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$9(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$9(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$9(t) {
	var i = _toPrimitive$9(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$9(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$9(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$9(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/**
* Service for writing MCP configuration files while preserving
* comments, formatting, and existing content.
*/
const McpConfigWriter = createInterfaceId("McpConfigWriter");
let _DefaultMcpConfigWrit;
(class {
	static {
		[_DefaultMcpConfigWrit, _initClass$9] = _applyDecs$9(this, [Service({
			dependencies: [Logger],
			lifetime: ServiceLifetime.Singleton
		}), Implements(McpConfigWriter)], []).c;
	}
	#logger;
	constructor(logger) {
		this.#logger = withPrefix(logger, "[MCP][ConfigWriter]");
	}
	upsertServer(filePath, serverName, config) {
		this.#logger.debug(`Upserting server "${serverName}" to ${filePath}`);
		return this.ensureConfigFile(filePath).andThen(() => this.#readFileContents(filePath)).andThen((content) => {
			const validationResult = ServerConfig.safeParse(config);
			if (!validationResult.success) return err(McpConfigurationError.fileValidationError(filePath, validationResult.error));
			const parsed = parseJSONC(content);
			const validated = this.#validateConfigStructure(parsed, filePath);
			if (validated.isErr()) return err(validated.error);
			const updatedConfig = {
				...validated.value,
				mcpServers: { ...validated.value.mcpServers },
				_managed: true
			};
			updatedConfig.mcpServers[serverName] = config;
			return ok(stringifyJSON(updatedConfig));
		}).andThen((newContent) => this.#writeFileContents(filePath, newContent)).map(() => {
			this.#logger.info(`Successfully upserted server "${serverName}" to ${filePath}`);
		});
	}
	deleteServer(filePath, serverName) {
		this.#logger.debug(`Deleting server "${serverName}" from ${filePath}`);
		return this.#readFileContents(filePath).andThen((content) => {
			const parsed = parseJSONC(content);
			const validated = this.#validateConfigStructure(parsed, filePath);
			if (validated.isErr()) return err(validated.error);
			if (!(serverName in validated.value.mcpServers)) return err(McpConfigurationError.serverNotFoundError(filePath, serverName));
			const updatedConfig = {
				...validated.value,
				mcpServers: { ...validated.value.mcpServers },
				_managed: true
			};
			delete updatedConfig.mcpServers[serverName];
			return ok(stringifyJSON(updatedConfig));
		}).andThen((newContent) => this.#writeFileContents(filePath, newContent)).map(() => {
			this.#logger.info(`Successfully deleted server "${serverName}" from ${filePath}`);
		});
	}
	ensureConfigFile(filePath, options = {}) {
		const managed = options.managed ?? true;
		return ResultAsync.fromPromise((async () => {
			try {
				await fs.access(filePath);
				const parsed = parseJSONC(await fs.readFile(filePath, "utf-8"));
				if (this.#validateConfigStructure(parsed, filePath).isErr()) {
					if (!managed) {
						this.#logger.warn(`Config file ${filePath} has invalid structure; leaving it untouched because it is unmanaged`);
						return;
					}
					this.#logger.warn(`Config file ${filePath} has invalid structure, reinitializing`);
					await this.#initializeConfigFile(filePath, managed);
				}
			} catch (error) {
				if (error.code === "ENOENT") {
					this.#logger.info(`Creating new config file at ${filePath}`);
					await this.#initializeConfigFile(filePath, managed);
				} else throw error;
			}
		})(), (error) => McpConfigurationError.fileWriteError(filePath, error));
	}
	isManagedConfig(filePath) {
		return this.#readFileContents(filePath).andThen((content) => {
			try {
				const parsed = parseJSONC(content);
				const validated = this.#validateConfigStructure(parsed, filePath);
				if (validated.isErr()) return ok(false);
				const config = validated.value;
				return ok(config._managed === true);
			} catch {
				return ok(false);
			}
		}).orElse((error) => {
			this.#logger.debug(`Could not check if ${filePath} is managed: ${error.message}`);
			return ok(false);
		});
	}
	/**
	* Validates that parsed JSON has the expected MCP config structure.
	* Returns Ok with validated config or Err with error.
	*/
	#validateConfigStructure(parsed, filePath) {
		if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return err(McpConfigurationError.fileReadError(filePath, /* @__PURE__ */ new Error("Config file must contain a JSON object")));
		const config = parsed;
		if (!("mcpServers" in config)) return err(McpConfigurationError.fileReadError(filePath, /* @__PURE__ */ new Error("Config file must contain \"mcpServers\" field")));
		if (!config.mcpServers || typeof config.mcpServers !== "object" || Array.isArray(config.mcpServers)) return err(McpConfigurationError.fileReadError(filePath, /* @__PURE__ */ new Error("\"mcpServers\" must be a JSON object")));
		return ok(config);
	}
	#readFileContents(filePath) {
		return ResultAsync.fromPromise(fs.readFile(filePath, "utf-8"), (error) => {
			return error?.code === "ENOENT" ? McpConfigurationError.fileNotFoundError(filePath) : McpConfigurationError.fileReadError(filePath, error);
		});
	}
	#writeFileContents(filePath, content) {
		return ResultAsync.fromPromise(fs.writeFile(filePath, content, "utf-8"), (error) => McpConfigurationError.fileWriteError(filePath, error));
	}
	async #initializeConfigFile(filePath, managed) {
		const dir = path$1.dirname(filePath);
		await fs.mkdir(dir, { recursive: true });
		const initialContent = `{${managed ? `\n  "_managed": true,` : ""}
  "mcpServers": {
    // Add your MCP server configurations here
    // See: https://docs.gitlab.com/user/gitlab_duo/model_context_protocol/mcp_server/
  }
}
`;
		await fs.writeFile(filePath, initialContent, "utf-8");
		this.#logger.info(`Initialized config file at ${filePath}`);
	}
	static {
		_initClass$9();
	}
});
//#endregion
//#region src/mcp/config/mcp_config_path_provider.ts
/** Provider-facing counterpart of `LoadCandidate`. Notably it has no `scope`: the
* manager stamps every contributed candidate as `plugin` so a provider cannot grant
* itself the auto-approved `user` scope. */
/**
* Port for contributing extra MCP configuration file candidates (e.g. from installed
* marketplace plugins). lib_ai_configuration owns this interface but ships no
* implementation and has no dependency on the marketplace package; a client (e.g. the
* CLI) registers the real implementation. With zero implementations registered,
* `McpManager` behaves exactly as it does without this port.
*/
const McpConfigPathProvider = createInterfaceId("McpConfigPathProvider");
//#endregion
//#region src/utils/paths.ts
/**
* Gets the base directory for Duo configuration files based on the platform.
* - Windows: %APPDATA%\GitLab\duo
* - macOS/Linux: $XDG_CONFIG_HOME/gitlab/duo or ~/.gitlab/duo
*
* @returns The path to the Duo configuration directory or undefined if required environment variables are missing
*/
function getDuoConfigDir() {
	const { platform } = process;
	if (platform === "win32") {
		const appData = process.env.APPDATA;
		if (!appData) return;
		return path$1.join(appData, "GitLab", "duo");
	}
	const xdgConfigHome = process.env.XDG_CONFIG_HOME;
	if (xdgConfigHome && xdgConfigHome.trim() !== "") return path$1.join(xdgConfigHome, "gitlab", "duo");
	try {
		return path$1.join(homedir(), ".gitlab", "duo");
	} catch {
		return;
	}
}
/**
* Gets the full path to a specific configuration file in the Duo directory
*
* @param filename The name of the configuration file
* @returns The full path to the configuration file or undefined if the Duo directory couldn't be determined
*/
function getDuoConfigFilePath(filename) {
	const duoDir = getDuoConfigDir();
	if (!duoDir) return;
	return path$1.join(duoDir, filename);
}
function getGlobalAgentsDir() {
	try {
		return path$1.join(homedir(), ".agents");
	} catch {
		return;
	}
}
function getTrustedReadableDirectories() {
	return [getGlobalAgentsDir(), process.env.GLAB_CONFIG_DIR || getDuoConfigDir()].filter((dir) => dir !== void 0);
}
function isContainedIn(dirs, p) {
	return dirs.some((dir) => {
		const rel = path$1.relative(dir, p);
		return !rel.startsWith("..") && !path$1.isAbsolute(rel);
	});
}
//#endregion
//#region src/mcp/utils/get_mcp_config_path_candidates.ts
function getMcpConfigPathCandidates(workspacePath) {
	const candidates = [];
	if (workspacePath && path.isAbsolute(workspacePath)) {
		const workspaceConfigPath = path.join(workspacePath, ".gitlab", "duo", "mcp.json");
		candidates.push({
			path: workspaceConfigPath,
			scope: "workspace"
		});
	}
	const userMcpConfigPath = getDuoConfigFilePath("mcp.json");
	if (userMcpConfigPath) candidates.push({
		path: userMcpConfigPath,
		scope: "user"
	});
	return candidates;
}
//#endregion
//#region src/mcp/utils/hash_server_config.ts
/** Canonicalize an object (deep, sorted keys) for stable hashing */
function canonicalize(v) {
	if (Array.isArray(v)) return v.map(canonicalize);
	if (v instanceof URL) return v.toString();
	if (v && typeof v === "object") {
		const obj = v;
		return Object.fromEntries(Object.keys(obj).sort().map((k) => [k, canonicalize(obj[k])]));
	}
	return v;
}
/**
* Compute a stable SHA-256 hash of a ServerConfig for use in server approval.
*
* The approval decision is about whether to trust the server binary/endpoint,
* so `approvedTools` is intentionally excluded: changing which tools are
* pre-approved should not invalidate an existing server-level approval and
* force the user to re-approve the server.
*
* The config is deep-canonicalized (keys sorted recursively) before hashing
* so that key-insertion order does not affect the result.
*/
function hashServerConfig(config) {
	return hashCanonically(withoutApprovedTools(config));
}
/**
* Approval key for a plugin-contributed template, qualified by the contributing
* plugin's id. Without that qualifier any two byte-identical templates share one
* decision, so approving plugin A's server would silently approve plugin B's — which
* runs a different binary whenever the two differ only in their `variables`.
*
* Deliberately not derived from the candidate's path: that lives under the plugin root
* the variables abstract away, so it would re-break approval stability across moves.
*/
function hashPluginServerConfig(pluginId, template) {
	return hashCanonically({
		scope: "plugin",
		pluginId,
		template: withoutApprovedTools(template)
	});
}
/**
* The approval decision is about whether to trust the server binary/endpoint, so
* `approvedTools` never contributes to a key. Shallow by design, and applied by each
* caller to the object that actually carries the field — for a plugin that is the nested
* template, not the wrapper it gets hashed inside.
*/
function withoutApprovedTools(config) {
	if (!config || typeof config !== "object" || Array.isArray(config)) return config;
	const { approvedTools: _excluded, ...rest } = config;
	return rest;
}
function hashCanonically(config) {
	const normalized = JSON.stringify(canonicalize(config));
	return crypto.createHash("sha256").update(normalized).digest("hex");
}
//#endregion
//#region src/mcp/utils/log_mcp_config_resolution.ts
function logMcpConfigResolution(logger, result, candidatePaths) {
	const statuses = Object.values(result.diagnostics);
	const successfulConfigs = statuses.filter((s) => s.status === "ok");
	const failedConfigs = statuses.filter((s) => s.status === "error");
	if (successfulConfigs.length > 0) {
		const paths = successfulConfigs.map((s) => s.path).join(", ");
		logger.info(`[MCP] Successfully loaded ${successfulConfigs.length} config file(s): ${paths}`);
	}
	const totalServersBeforeMerge = successfulConfigs.reduce((sum, s) => sum + Object.keys(s.config.mcpServers).length, 0);
	if (totalServersBeforeMerge > 0) logger.info(`[MCP] Found ${totalServersBeforeMerge} total server(s) across all config files`);
	failedConfigs.forEach((status) => {
		const { error, path: filePath } = status;
		switch (error.code) {
			case "MCP_CONFIGURATION_FILE_NOT_FOUND_ERROR":
				logger.debug(`[MCP] Config file not found: ${filePath}`);
				break;
			case "MCP_CONFIGURATION_FILE_READ_ERROR":
				logger.error(`[MCP] Failed to read config file ${filePath}: ${error.message}`);
				if (error.cause) logger.debug(`[MCP] IO error details: ${error.cause}`);
				break;
			case "MCP_CONFIGURATION_FILE_JSON_PARSE_ERROR":
				logger.error(`[MCP] Invalid JSON in config file ${filePath}`);
				if (error.cause) logger.debug(`[MCP] Parse error: ${error.cause}`);
				break;
			case "MCP_CONFIGURATION_FILE_VALIDATION_ERROR": {
				logger.error(`[MCP] Validation failed for ${filePath}:`);
				const tree = treeifyError(error.issues);
				logger.debug(JSON.stringify(tree, null, 2));
				break;
			}
			default: logger.error(`[MCP] Unexpected error with config file ${filePath}: ${error}`);
		}
	});
	const duplicateServers = Object.entries(result.serversOrigin).filter(([, origin]) => origin.paths.length > 1).map(([key, origin]) => ({
		key,
		winner: origin.resolvedPath,
		winnerIndex: origin.index,
		losers: origin.paths.filter((path) => path !== origin.resolvedPath)
	}));
	if (duplicateServers.length > 0) {
		logger.info(`[MCP] Found ${duplicateServers.length} duplicate server definition(s)`);
		duplicateServers.forEach((dup) => {
			logger.info(`[MCP] Server '${dup.key}' defined in multiple configs. Using definition from '${dup.winner}' (priority ${dup.winnerIndex + 1}), ignoring: ${dup.losers.join(", ")}`);
		});
	}
	const finalServers = Object.entries(result.config.mcpServers);
	if (finalServers.length > 0) {
		const serverDetails = finalServers.map(([key, server]) => {
			const { type } = server;
			return `${key} (${type} from ${result.serversOrigin[key]?.resolvedPath})`;
		});
		logger.debug(`[MCP] Final merged configuration contains ${finalServers.length} server(s): ${serverDetails.join(", ")}`);
	} else if (successfulConfigs.length > 0) logger.warn("[MCP] No servers found in any configuration files");
	if (candidatePaths.length > 1) logger.debug(`[MCP] Config file precedence (highest to lowest): ${candidatePaths.join(" > ")}`);
	const serverTypeCounts = finalServers.reduce((acc, [_, server]) => {
		const { type } = server;
		acc[type] = (acc[type] || 0) + 1;
		return acc;
	}, {});
	if (Object.keys(serverTypeCounts).length > 0) {
		const typeSummary = Object.entries(serverTypeCounts).map(([type, count]) => `${count} ${type}`).join(", ");
		logger.debug(`[MCP] Server types: ${typeSummary}`);
	}
}
//#endregion
//#region src/mcp/utils/slugify_server_name.ts
/**
* Convert an arbitrary server display name into a safe internal slug
* that satisfies the ServerName regex: /^[a-zA-Z0-9_.-]+$/
*
* Rules:
*  - Lowercase
*  - Replace runs of non-alphanumeric/dot/hyphen chars with a single `_`
*  - Trim leading/trailing `_`
*  - Truncate to 250 chars (ServerName max)
*  - Already-valid names pass through lowercased only
*
* Returns null if the input produces an empty slug.
*/
function slugifyServerName(raw) {
	const slug = raw.toLowerCase().replace(/[^a-z0-9._-]+/g, "_").replace(/_{2,}/g, "_").replace(/^_+|_+$/g, "").slice(0, 250);
	if (slug.length <= 0) return null;
	const parseResult = ServerName.safeParse(slug);
	return parseResult.success ? parseResult.data : null;
}
//#endregion
//#region src/mcp/config/expand_variables.ts
const TOKEN_REGEX = /\$\{([A-Za-z0-9_]+)\}/g;
function expandString(value, variables) {
	return value.replace(TOKEN_REGEX, (match, name) => Object.prototype.hasOwnProperty.call(variables, name) ? variables[name] : match);
}
/**
* Expand exact `${NAME}` tokens (no recursion) in every string of a raw, not-yet-
* validated server config. Unknown tokens are left untouched; the input is not mutated.
*
* Runs before schema validation so a token works in any string position. Expanding
* afterwards cannot: the schema turns `url` into a `URL`, and `new URL()` lowercases
* the host (so `${NAME}` becomes an unmatchable `${name}`) and rejects braces outright
* in a port.
*/
function expandServerConfigVariables(rawConfig, variables) {
	if (typeof rawConfig === "string") return expandString(rawConfig, variables);
	if (Array.isArray(rawConfig)) return rawConfig.map((entry) => expandServerConfigVariables(entry, variables));
	if (rawConfig && typeof rawConfig === "object") return Object.fromEntries(Object.entries(rawConfig).map(([key, value]) => [key, expandServerConfigVariables(value, variables)]));
	return rawConfig;
}
//#endregion
//#region src/mcp/config/sanitize_workspace_sandbox.ts
const NARROWING_KEY = "denyRead";
/**
* Reduce a workspace-sourced sandbox override to its narrowing-only subset.
*
* Allowlist, not denylist: the result is rebuilt from `denyRead` alone, so any
* widening field — `allowWrite`, `allowedDomains`, `sandboxEnabled`, or an
* unknown/future key — is discarded rather than depending on an enumerated block
* list. Returns the sanitized override (or `undefined` when nothing narrowing
* survives) plus the names of the stripped keys, for logging.
*/
function sanitizeWorkspaceSandbox(sandbox) {
	const stripped = Object.keys(sandbox).filter((key) => key !== NARROWING_KEY && sandbox[key] !== void 0);
	const { denyRead } = sandbox;
	return {
		sanitized: denyRead?.length ? { denyRead } : void 0,
		stripped
	};
}
//#endregion
//#region src/mcp/config/default_resolver.ts
let _initClass$8;
function _applyDecs$8(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$8(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$8(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$8(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$8(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$8(t) {
	var i = _toPrimitive$8(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$8(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$8(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$8(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
/** A parse result before the candidate-dependent `approvalHash` is attached. */
function isSuccess(candidate) {
	return candidate.status === "ok";
}
function isFileNotFoundError(candidate) {
	return candidate.status === "error" && candidate.error?.code === "MCP_CONFIGURATION_FILE_NOT_FOUND_ERROR";
}
const EMPTY_RESOLVED_MCP_CONFIG = {
	config: { mcpServers: {} },
	serversOrigin: {},
	diagnostics: {}
};
let _DefaultMcpConfigReso;
(class {
	static {
		[_DefaultMcpConfigReso, _initClass$8] = _applyDecs$8(this, [Service({
			dependencies: [Logger],
			lifetime: ServiceLifetime.Singleton
		}), Implements(McpConfigResolver)], []).c;
	}
	#logger;
	constructor(logger) {
		this.#logger = withPrefix(logger, "[MCP][Config]");
	}
	async loadAndMerge(candidates) {
		if (candidates.length === 0) return EMPTY_RESOLVED_MCP_CONFIG;
		const resolutionTasks = candidates.map(async (candidate, index) => {
			return (await this.#loadAndValidate(candidate)).match(({ config, serverResults, displayNames }) => ({
				index,
				path: candidate.path,
				scope: candidate.scope,
				status: "ok",
				config,
				serverResults,
				displayNames
			}), (error) => ({
				index,
				path: candidate.path,
				scope: candidate.scope,
				status: "error",
				error
			}));
		});
		const candidateStatuses = await Promise.all(resolutionTasks);
		const successCount = candidateStatuses.filter((c) => c.status === "ok").length;
		const notFoundCount = candidateStatuses.filter(isFileNotFoundError).length;
		const errorCount = candidateStatuses.filter((c) => c.status === "error" && !isFileNotFoundError(c)).length;
		const totalServers = candidateStatuses.filter((c) => c.status === "ok").reduce((sum, c) => sum + Object.keys(c.serverResults).length, 0);
		const validServers = candidateStatuses.filter((c) => c.status === "ok").reduce((sum, c) => sum + Object.keys(c.config.mcpServers).length, 0);
		this.#logger.info(`configs_loaded — total=${candidateStatuses.length} ok=${successCount} not_found=${notFoundCount} error=${errorCount} servers=${validServers}/${totalServers}`);
		return this.#mergeCandidates(candidateStatuses);
	}
	#readFileContents(filePath) {
		return ResultAsync.fromPromise(import("fs/promises").then((fs) => fs.readFile(filePath, "utf8")), (error) => {
			return error?.code === "ENOENT" ? McpConfigurationError.fileNotFoundError(filePath) : McpConfigurationError.fileReadError(filePath, error);
		});
	}
	#parseJsonContents(filePath, rawContents) {
		const errors = [];
		const parseResult = Result.fromThrowable(() => parseJSONC(rawContents, {
			errors,
			allowTrailingComma: true
		}), (error) => McpConfigurationError.fileJsonParseError(filePath, error))();
		if (errors.length > 0) {
			const error = errors[0];
			const message = `[MCP] JSON parsing error at offset ${error?.offset} (length: ${error?.length})`;
			return err(McpConfigurationError.fileJsonParseError(filePath, new Error(message)));
		}
		return parseResult;
	}
	/**
	* Hash a server config object to detect changes
	*/
	#hashServerConfig(serverConfig) {
		const json = JSON.stringify(serverConfig);
		return createHash("sha256").update(json).digest("hex");
	}
	/**
	* Parse a single server config with hash and error tracking. `approvalHash` is left to
	* the caller, which alone knows the candidate the config came from.
	*/
	#parseServerConfig(rawConfig) {
		const hash = this.#hashServerConfig(rawConfig);
		const parsed = ServerConfig.safeParse(rawConfig);
		if (parsed.success) return {
			success: true,
			config: parsed.data,
			hash
		};
		return {
			success: false,
			config: rawConfig,
			hash,
			error: parsed.error
		};
	}
	/**
	* Validate basic configuration shape and parse individual servers
	*/
	#validateConfiguration(candidate, untypedValue) {
		const basicParsed = BasicConfiguration.safeParse(untypedValue);
		if (!basicParsed.success) return err(McpConfigurationError.fileValidationError(candidate.path, basicParsed.error));
		const slugToQualifiedName = /* @__PURE__ */ new Map();
		const resolved = Object.entries(basicParsed.data.mcpServers).map(([rawName, rawConfig]) => this.#resolveServerEntry(candidate, rawName, rawConfig, slugToQualifiedName)).filter((entry) => entry !== null);
		const serverResults = {};
		const validServers = {};
		const displayNames = {};
		for (const { slug, displayName, parseResult } of resolved) {
			serverResults[slug] = parseResult;
			displayNames[slug] = displayName;
			if (parseResult.success) validServers[slug] = parseResult.config;
		}
		return ok({
			config: { mcpServers: validServers },
			serverResults,
			displayNames
		});
	}
	/**
	* Slugify, validate, and parse a single server entry from config.
	* Returns null (with logging) if the entry should be skipped.
	*
	* The slug comes from `namePrefix` and the display name from `displayNamePrefix`, so a
	* contributor can be uniquely namespaced without that qualification reaching the user.
	* Collision detection keys on the qualified name, since that is what the slug derives
	* from — display names carry no identity and may repeat.
	*/
	#resolveServerEntry(candidate, rawName, rawConfig, slugToQualifiedName) {
		const { path: filePath, namePrefix, displayNamePrefix } = candidate;
		const qualifiedName = namePrefix ? `${namePrefix}${rawName}` : rawName;
		const displayName = displayNamePrefix ? `${displayNamePrefix}${rawName}` : qualifiedName;
		const slug = slugifyServerName(qualifiedName);
		if (!slug) {
			this.#logger.warn(`Server "${qualifiedName}" in ${filePath}: name could not be converted to a valid server identifier, skipping`);
			return null;
		}
		const existing = slugToQualifiedName.get(slug);
		if (existing && existing !== qualifiedName) {
			this.#logger.warn(`Server names "${qualifiedName}" and "${existing}" in ${filePath} both resolve to internal identifier "${slug}". Keeping "${existing}", skipping "${qualifiedName}".`);
			return null;
		}
		slugToQualifiedName.set(slug, qualifiedName);
		const parseResult = this.#parseCandidateServerConfig(candidate, rawConfig, displayName);
		if (!parseResult.success) this.#logServerValidationErrors(displayName, filePath, parseResult);
		return {
			slug,
			displayName,
			parseResult
		};
	}
	/**
	* A candidate declaring `variables` is validated on its expanded form only: the
	* template can't be validated as-is, since a token in a URL host or port is not a
	* valid URL. `hash` therefore tracks the expanded content, while `approvalHash` is
	* keyed per `#serverApprovalHash`. A non-`user` (workspace or plugin) candidate's
	* sandbox override is narrowed before either hash is computed, so approval and
	* change-detection are keyed to what will actually run.
	*/
	#parseCandidateServerConfig(candidate, rawConfig, displayName) {
		const { variables } = candidate;
		const parsed = this.#parseServerConfig(variables ? expandServerConfigVariables(rawConfig, variables) : rawConfig);
		if (!parsed.success) return parsed;
		const config = this.#enforceSandboxScope(parsed.config, candidate, displayName);
		return {
			...parsed,
			config,
			approvalHash: this.#serverApprovalHash(candidate, rawConfig, config)
		};
	}
	#enforceSandboxScope(config, candidate, displayName) {
		if (candidate.scope === "user" || config.type !== "stdio" || !config.sandbox) return config;
		const { sanitized, stripped } = sanitizeWorkspaceSandbox(config.sandbox);
		if (stripped.length > 0) {
			const userConfigPath = getDuoConfigFilePath("mcp.json");
			this.#logger.warn(`Server "${displayName}" in ${candidate.path}: sandbox settings from this project's committed config can only narrow, not widen (ignored: ${stripped.join(", ")}). To grant these permissions, add them to your personal config instead${userConfigPath ? `: ${userConfigPath}` : ""}.`);
		}
		const { sandbox: _prev, ...rest } = config;
		return sanitized ? {
			...rest,
			sandbox: sanitized
		} : rest;
	}
	/**
	* Plugin candidates are keyed on the contributor id plus the pre-expansion template, so
	* a decision survives the plugin root moving without being shared with another
	* contributor shipping the same template.
	*/
	#serverApprovalHash(candidate, rawConfig, parsedConfig) {
		return candidate.scope === "plugin" ? hashPluginServerConfig(candidate.id, rawConfig) : hashServerConfig(parsedConfig);
	}
	/**
	* Log user-friendly validation errors for a server config.
	*/
	#logServerValidationErrors(rawName, filePath, parseResult) {
		const errorMessages = parseResult.error.issues.map((issue) => {
			const path = issue.path.length > 0 ? issue.path.join(".") : "config";
			let { message } = issue;
			if (path === "type" || issue.path.includes("type")) message = `The "type" field is required and must be one of: "stdio", "sse", or "http"`;
			return `  - Field "${path}": ${message}`;
		});
		const hint = parseResult.error.issues.some((issue) => issue.path.includes("type") || issue.path[0] === "type") ? "\n  Hint: See https://docs.gitlab.com/user/gitlab_duo/model_context_protocol/mcp_server/ for configuration details" : "";
		this.#logger.warn(`Server "${rawName}" has invalid config in ${filePath}:\n${errorMessages.join("\n")}${hint}`);
	}
	#loadAndValidate(candidate) {
		return this.#readFileContents(candidate.path).andThen((rawContents) => this.#parseJsonContents(candidate.path, rawContents)).andThen((jsonValue) => this.#validateConfiguration(candidate, jsonValue));
	}
	#mergeCandidates(candidates) {
		const initial = {
			config: { mcpServers: {} },
			serversOrigin: {},
			diagnostics: {}
		};
		const orderedCandidates = [...candidates].sort((a, b) => a.index - b.index);
		const merged = orderedCandidates.reduce((acc, candidate) => {
			acc.diagnostics[candidate.path] = candidate;
			if (isSuccess(candidate)) for (const [serverName, parseResult] of Object.entries(candidate.serverResults)) if (!(serverName in acc.serversOrigin)) {
				acc.serversOrigin[serverName] = {
					index: candidate.index,
					scope: candidate.scope,
					displayName: candidate.displayNames[serverName] ?? serverName,
					resolvedPath: candidate.path,
					paths: [candidate.path],
					hash: parseResult.hash,
					parseResult
				};
				if (parseResult.success) acc.config.mcpServers[serverName] = parseResult.config;
			} else {
				const origin = acc.serversOrigin[serverName];
				if (origin) origin.paths.push(candidate.path);
			}
			return acc;
		}, initial);
		const totalServers = Object.keys(merged.serversOrigin).length;
		const validServers = Object.keys(merged.config.mcpServers).length;
		const invalidServers = totalServers - validServers;
		if (totalServers === 0 && orderedCandidates.some((c) => c.status === "ok")) this.#logger.warn("no_servers_found_in_valid_configs");
		else if (invalidServers > 0) this.#logger.warn(`${invalidServers} server(s) have invalid configuration`);
		else this.#logger.debug(`${validServers} server(s) loaded`);
		return merged;
	}
	static {
		_initClass$8();
	}
});
//#endregion
//#region src/mcp/config/di.ts
function registerMcpConfigService(serviceCollection) {
	serviceCollection.addClass(_DefaultMcpConfigReso);
	serviceCollection.addClass(_DefaultMcpConfigWrit);
}
//#endregion
//#region src/mcp/client/utils/async_cache.ts
/**
* Generic async cache with:
* - Single-flight fetches (deduplication)
* - Optional TTL
*/
var AsyncCache = class {
	#fetcher;
	#ttlMs;
	#version = 0;
	#cached;
	#expiresAt;
	#inflight;
	#inflightVersion = -1;
	#abortController;
	constructor(opts) {
		this.#fetcher = opts.fetcher;
		this.#ttlMs = opts.ttlMs;
	}
	/**
	* Get cached value if fresh, otherwise fetch (with deduplication).
	*/
	get() {
		if (this.#cached !== void 0 && !this.#isExpired()) return okAsync(this.#cached);
		return this.#fetch(false);
	}
	/**
	* Force a fresh fetch, aborting any in-flight request.
	*/
	refresh() {
		this.#abortInflight();
		this.#version += 1;
		return this.#fetch(true);
	}
	/**
	* Clear cached value and abort any in-flight request.
	*/
	clear() {
		this.#abortInflight();
		this.#cached = void 0;
		this.#expiresAt = void 0;
		this.#version += 1;
	}
	/**
	* Check if there's a valid cached value.
	*/
	has() {
		return this.#cached !== void 0 && !this.#isExpired();
	}
	/**
	* Clean up resources. Call when disposing the cache.
	*/
	dispose() {
		this.#abortInflight();
		this.#cached = void 0;
		this.#expiresAt = void 0;
	}
	#isExpired() {
		if (this.#ttlMs == null) return false;
		if (this.#expiresAt == null) return true;
		return Date.now() >= this.#expiresAt;
	}
	#abortInflight() {
		if (this.#abortController) this.#abortController.abort();
		this.#abortController = void 0;
		this.#inflight = void 0;
		this.#inflightVersion = -1;
	}
	#fetch(force) {
		if (!force && this.#inflight) return this.#inflight;
		this.#abortInflight();
		const controller = new AbortController();
		const myVersion = this.#version;
		this.#abortController = controller;
		const task = this.#fetcher(controller.signal).andTee((value) => {
			if (!controller.signal.aborted && myVersion === this.#version) {
				this.#cached = value;
				this.#expiresAt = this.#ttlMs == null ? void 0 : Date.now() + this.#ttlMs;
			}
			if (this.#inflightVersion === myVersion) {
				this.#abortController = void 0;
				this.#inflight = void 0;
				this.#inflightVersion = -1;
			}
		});
		this.#inflight = task;
		this.#inflightVersion = myVersion;
		return task;
	}
};
//#endregion
//#region src/mcp/client/errors.ts
const formatCauseValue = (value) => {
	if (value === void 0 || value === null) return null;
	if (value instanceof Error) return value.message;
	if (typeof value === "string") return value;
	if (typeof value === "object" && value !== null && "text" in value) {
		const textValue = value.text;
		if (typeof textValue === "string" && textValue.trim()) return textValue;
	}
	try {
		return JSON.stringify(value);
	} catch {
		return String(value);
	}
};
const formatErrorCause = (cause) => {
	if (Array.isArray(cause)) {
		const fragments = cause.map((entry) => formatCauseValue(entry)).filter((entry) => Boolean(entry?.trim()));
		return fragments.length > 0 ? fragments.join(" ") : null;
	}
	return formatCauseValue(cause);
};
const withOptionalCause = (baseMessage, cause) => {
	const formattedCause = formatErrorCause(cause);
	if (!formattedCause) return baseMessage;
	return `${baseMessage}. Cause: ${formattedCause}`;
};
const McpError = {
	connectionFailed: (serverName, cause) => createError("MCP_CONNECTION_FAILED", `Failed to connect to MCP server: ${serverName}`, {
		serverName,
		cause
	}),
	authRequired: (serverName, authUrl) => createError("MCP_AUTH_REQUIRED", `Authentication required for MCP server: ${serverName}`, {
		serverName,
		authUrl
	}),
	authFailed: (serverName, cause) => createError("MCP_AUTH_FAILED", `Authentication failed for MCP server: ${serverName}`, {
		serverName,
		cause
	}),
	clientNotConnected: (serverName, currentState) => createError("MCP_CLIENT_NOT_CONNECTED", `Client ${serverName} is not connected (state: ${currentState})`, {
		serverName,
		currentState
	}),
	clientDisposed: (serverName) => createError("MCP_CLIENT_DISPOSED", `Client ${serverName} is disposed`, { serverName }),
	toolExecutionFailed: (serverName, toolName, cause) => createError("MCP_TOOL_EXECUTION_FAILED", withOptionalCause(`Failed to execute tool ${toolName} on server ${serverName}`, cause), {
		serverName,
		toolName,
		cause
	}),
	listToolsFailed: (serverName, cause) => createError("MCP_LIST_TOOLS_FAILED", `Failed to list tools for server ${serverName}`, {
		serverName,
		cause
	}),
	serverVersionUnavailable: (serverName) => createError("MCP_SERVER_VERSION_UNAVAILABLE", `Server version information is not available for ${serverName}`, { serverName }),
	transportCreationFailed: (serverName, transportType, cause) => createError("MCP_TRANSPORT_CREATION_FAILED", `Failed to create ${transportType} transport for server ${serverName}`, {
		serverName,
		transportType,
		cause
	})
};
//#endregion
//#region src/mcp/client/client.ts
/**
* High-level client interface for interacting with an MCP server.
* Only exists when the connection is in Connected state.
* Automatically becomes invalid if the connection is lost.
*/
var McpClient = class {
	#sdkClient;
	#serverName;
	#logger;
	#toolCache;
	#disposed = false;
	#notificationCleanup;
	constructor(sdkClient, serverName, logger) {
		this.#sdkClient = sdkClient;
		this.#serverName = serverName;
		this.#logger = logger;
		this.#toolCache = new AsyncCache({ fetcher: (signal) => this.#fetchTools(signal) });
		this.#setupNotifications();
	}
	/**
	* Get available tools from the server (cached).
	* Cache is automatically invalidated when server sends list_changed notification.
	*/
	getTools() {
		this.#ensureNotDisposed();
		return this.#toolCache.get();
	}
	/**
	* Force refresh tools from the server, bypassing cache.
	*/
	async refreshTools() {
		this.#ensureNotDisposed();
		this.#logger.debug("Forcing tool refresh");
		return this.#toolCache.refresh();
	}
	/**
	* Execute a tool on the server.
	*/
	executeTool(toolName, args) {
		this.#ensureNotDisposed();
		this.#logger.debug(`Executing tool="${toolName}" args=${JSON.stringify(args)}`);
		return ResultAsync.fromPromise(this.#sdkClient.callTool({
			name: toolName,
			arguments: args
		}), (error) => McpError.toolExecutionFailed(this.#serverName, toolName, error)).orTee((e) => this.#logger.debug(`Tool call failed - error="${e.message}"`)).andThen((result) => {
			if (result.isError) {
				this.#logger.error(`Tool execution error tool="${toolName}"`, result);
				return errAsync(McpError.toolExecutionFailed(this.#serverName, toolName, result.content));
			}
			const textContent = result.content.filter((item) => item.type === "text").map((item) => "text" in item ? item.text : "").join("\n");
			return ResultAsync.fromSafePromise(Promise.resolve(textContent));
		}).andTee(() => this.#logger.debug(`Tool execution succeeded tool="${toolName}"`));
	}
	/**
	* Dispose and cleanup resources.
	* After disposal, all methods will throw.
	*/
	dispose() {
		if (this.#disposed) return;
		this.#disposed = true;
		this.#notificationCleanup?.();
		this.#notificationCleanup = void 0;
		this.#toolCache.dispose();
	}
	#setupNotifications() {
		try {
			this.#sdkClient.setNotificationHandler(ToolListChangedNotificationSchema, async () => {
				if (this.#disposed) return;
				this.#logger.debug("Received notifications/tools/list_changed notification");
				await this.#toolCache.refresh();
			});
			this.#notificationCleanup = () => {
				this.#sdkClient.removeNotificationHandler("notifications/tools/list_changed");
			};
		} catch (error) {
			this.#logger.warn("Failed to setup tool change notifications", error);
		}
	}
	#fetchTools(signal) {
		this.#logger.debug("Fetching tools from server");
		return ResultAsync.fromPromise(this.#sdkClient.listTools({}, { signal }), (error) => McpError.listToolsFailed(this.#serverName, error)).map((result) => {
			const mapped = result.tools.map((tool) => ({
				name: McpToolName.create({
					serverName: this.#serverName,
					toolName: tool.name
				}),
				originalToolName: tool.name,
				serverName: this.#serverName,
				description: tool.description || "",
				inputSchema: JSON.stringify(tool.inputSchema),
				isApproved: false
			}));
			this.#logger.debug(`Fetched tools count=${mapped.length}`);
			return mapped;
		});
	}
	#ensureNotDisposed() {
		if (this.#disposed) throw new Error("McpClient has been disposed");
	}
};
//#endregion
//#region src/mcp/client/utils/auth.ts
function isOAuthCapable(transport) {
	return "finishAuth" in transport && typeof transport.finishAuth === "function";
}
/**
* Complete OAuth authentication flow and create new transport.
*
* This utility handles the OAuth authentication sequence:
* 1. Validates the authorization code (null indicates timeout)
* 2. Verifies transport supports OAuth (has finishAuth method)
* 3. Completes OAuth handshake with current transport
* 4. Creates new authenticated transport via provider
*
* @param serverName - Server being authenticated
* @param currentTransport - Transport that initiated OAuth flow
* @param code - OAuth authorization code from callback (null = timeout)
* @param transportProvider - Provider to create new transport instance
* @returns New transport ready to connect, or error
*
* @remarks
* The returned transport is NOT yet connected to the SDK client.
* Caller is responsible for:
* - Connecting the new transport via Client.connect()
* - Disposing the old transport
* - Updating connection state
* - Setting up connection monitoring
*/
function finishOAuthFlow(serverName, currentTransport, code, transportProvider) {
	if (code === null) return errAsync(McpError.authFailed(serverName, "Authentication timeout"));
	if (!isOAuthCapable(currentTransport)) return errAsync(McpError.transportCreationFailed(serverName, "oauth", "Transport does not support OAuth authentication"));
	return ResultAsync.fromPromise(currentTransport.finishAuth(code), (error) => McpError.authFailed(serverName, error)).andThen(() => transportProvider.create().mapErr((e) => McpError.transportCreationFailed(serverName, "oauth-refresh", e)));
}
//#endregion
//#region src/mcp/client/connection.ts
let ConnectionState = /* @__PURE__ */ function(ConnectionState) {
	ConnectionState["Connecting"] = "connecting";
	ConnectionState["Authenticating"] = "authenticating";
	ConnectionState["Connected"] = "connected";
	ConnectionState["Disconnected"] = "disconnected";
	ConnectionState["Failed"] = "failed";
	ConnectionState["PendingApproval"] = "pendingApproval";
	ConnectionState["Rejected"] = "rejected";
	return ConnectionState;
}({});
var DefaultMcpConnection = class {
	#serverName;
	#serverInfo;
	#sdkClient;
	#logger;
	#eventBus = new EventEmitter$1();
	#transportProvider;
	#authFinalizerRegistry;
	#authFlowController;
	#state = { status: ConnectionState.Disconnected };
	#transport;
	#disposed = false;
	#serverClient;
	#connectionPromise;
	#authRegistered = false;
	#transportDisposables = new CompositeDisposable();
	#pendingAuthFlowUrl;
	constructor(sdkClient, transport, transportProvider, serverInfo, logger, authFlowController, authFinalizerRegistry) {
		this.#serverName = serverInfo.name;
		this.#serverInfo = serverInfo;
		this.#sdkClient = sdkClient;
		this.#transport = transport;
		this.#transportProvider = transportProvider;
		this.#logger = withPrefix(logger, `[MCP][Connection][${serverInfo.name}]`);
		this.#authFlowController = authFlowController;
		this.#authFinalizerRegistry = authFinalizerRegistry;
		this.#setupConnectionMonitoring();
	}
	get state() {
		if (this.#disposed) return ConnectionState.Disconnected;
		return this.#state.status;
	}
	get serverName() {
		return this.#serverName;
	}
	getStateSnapshot() {
		if (this.#disposed) return { status: ConnectionState.Disconnected };
		return this.#state;
	}
	/**
	* Attempt initial connection to the server.
	* Called by factory after construction to complete the two-phase initialization.
	* Handlers are already registered, so auth URL events will be received.
	*
	* @internal - Only called by McpConnectionFactory
	*/
	attemptConnect() {
		if (this.#state.status !== ConnectionState.Disconnected) return errAsync(McpError.connectionFailed(this.#serverName, "Cannot connect - already connecting/connected"));
		this.#registerAuthHandler();
		this.#logger.debug("Attempting initial connection...");
		this.#setState({
			status: ConnectionState.Connecting,
			config: this.#serverInfo.config,
			startedAt: /* @__PURE__ */ new Date()
		});
		return ResultAsync.fromPromise(this.#sdkClient.connect(this.#transport), (e) => e).andTee(() => {
			this.#logger.info("Connected successfully");
			this.#setState({
				status: ConnectionState.Connected,
				config: this.#serverInfo.config,
				connectedAt: /* @__PURE__ */ new Date()
			});
		}).orElse((err) => {
			if (err instanceof UnauthorizedError) {
				this.#logger.info("Authentication required");
				this.#setState({
					status: ConnectionState.Authenticating,
					config: this.#serverInfo.config,
					startedAt: /* @__PURE__ */ new Date(),
					authUrl: this.#pendingAuthFlowUrl
				});
				this.#pendingAuthFlowUrl = void 0;
				return ok();
			}
			const cause = err instanceof Error && "cause" in err && err.cause instanceof Error ? err.cause : void 0;
			if (cause) this.#logger.warn(`Connection failed - cause="${cause}"`, cause);
			this.#logger.warn(`Connection failed - error="${err}"`, err);
			this.#setState({
				status: ConnectionState.Failed,
				config: this.#serverInfo.config,
				error: McpError.connectionFailed(this.#serverName, err),
				failedAt: /* @__PURE__ */ new Date()
			});
			return errAsync(McpError.connectionFailed(this.#serverName, err));
		});
	}
	/**
	* Complete OAuth authentication.
	* Only valid when state is Authenticating.
	*/
	finishAuth(code) {
		if (this.#disposed) return errAsync(McpError.clientDisposed(this.#serverName));
		if (this.#state.status !== ConnectionState.Authenticating) {
			this.#logger.debug("Invalid state - cannot finish auth when not in Authenticating state");
			return errAsync(McpError.clientNotConnected(this.#serverName, this.#state.status));
		}
		return finishOAuthFlow(this.#serverName, this.#transport, code, this.#transportProvider).andThen((newTransport) => this.#connectNewTransport(newTransport)).andTee((newTransport) => this.#handleAuthSuccess(newTransport)).orTee((error) => this.#handleAuthFailure(error)).map(() => void 0);
	}
	/**
	* Wait for the connection to complete and return the high-level client.
	* Can be called multiple times - returns the same promise/result.
	*
	* @returns Connected client on success, or error on failure
	*/
	waitForConnection() {
		if (this.#disposed) return errAsync(McpError.clientDisposed(this.#serverName));
		const currentState = this.#state;
		if (currentState.status === ConnectionState.Connected && this.#serverClient) return okAsync(this.#serverClient);
		if (currentState.status === ConnectionState.Failed || currentState.status === ConnectionState.Disconnected) return errAsync(currentState.status === ConnectionState.Failed ? currentState.error : McpError.connectionFailed(this.#serverName, "Connection disconnected"));
		if (this.#connectionPromise) return ResultAsync.fromPromise(this.#connectionPromise, (e) => e).andThen((r) => r);
		this.#connectionPromise = new Promise((resolve) => {
			const handleStateChange = (state) => {
				if (state.status === ConnectionState.Connected) {
					this.#eventBus.off("state_changed", handleStateChange);
					if (this.#serverClient) resolve(okAsync(this.#serverClient));
					else resolve(errAsync(McpError.connectionFailed(this.#serverName, "Client not initialized")));
				} else if (state.status === ConnectionState.Failed || state.status === ConnectionState.Disconnected) {
					this.#eventBus.off("state_changed", handleStateChange);
					resolve(errAsync(state.status === ConnectionState.Failed ? state.error : McpError.connectionFailed(this.#serverName, "Disconnected")));
				}
			};
			this.#eventBus.on("state_changed", handleStateChange);
			if (this.#state.status === ConnectionState.Connected && this.#serverClient) this.#emitStateChange();
			else if (this.#state.status === ConnectionState.Failed || this.#state.status === ConnectionState.Disconnected) this.#emitStateChange();
		});
		return ResultAsync.fromPromise(this.#connectionPromise, (e) => e).andThen((r) => r);
	}
	/**
	* Get the high-level server client if currently connected.
	* Returns immediately - does not wait for connection to complete.
	*
	* @returns McpClient if connected, or error if not connected
	*/
	getConnectedClient() {
		if (this.#disposed) return errAsync(McpError.clientDisposed(this.#serverName));
		if (this.#state.status !== ConnectionState.Connected) return errAsync(McpError.clientNotConnected(this.#serverName, this.#state.status));
		if (!this.#serverClient) return errAsync(McpError.connectionFailed(this.#serverName, "Client not initialized"));
		return okAsync(this.#serverClient);
	}
	onStateChanged(handler) {
		this.#eventBus.on("state_changed", handler);
		return () => this.#eventBus.off("state_changed", handler);
	}
	dispose() {
		if (this.#disposed) return;
		this.#disposed = true;
		this.#destroyServerClient();
		this.#transportDisposables.dispose();
		Promise.allSettled([this.#transport.close?.().catch(() => {}), this.#sdkClient.close()]).catch(() => {});
		this.#setState({ status: ConnectionState.Disconnected });
		this.#eventBus.removeAllListeners();
	}
	#setupConnectionMonitoring() {
		this.#transportDisposables.dispose();
		this.#transportDisposables = new CompositeDisposable();
		this.#setupStderrLogging();
		this.#transport.onerror = (error) => {
			this.#logger.error("Transport error", error);
			this.#handleConnectionLost("Transport error", error);
		};
		this.#transport.onclose = () => {
			this.#logger.info("Transport closed");
			this.#handleConnectionLost("Transport closed");
		};
		this.#transportDisposables.add({ dispose: () => {
			this.#transport.onerror = void 0;
		} }, { dispose: () => {
			this.#transport.onclose = void 0;
		} });
	}
	#setupStderrLogging() {
		if (!("stderr" in this.#transport)) return;
		const stderrStream = this.#transport.stderr;
		if (!stderrStream) return;
		const maxBufferSize = 1024 * 1024;
		let buffer = "";
		stderrStream.on("data", (chunk) => {
			buffer += chunk.toString("utf8");
			if (buffer.length > maxBufferSize) {
				this.#logger.warn(`[MCP Server stderr] Buffer exceeded ${maxBufferSize} bytes, dumping...`);
				this.#logger.info(`[MCP Server stderr] ${buffer}`);
				buffer = "";
				return;
			}
			const lines = buffer.split("\n");
			buffer = lines.pop() || "";
			for (const line of lines) if (line.trim()) this.#logger.info(`[MCP Server stderr] ${line}`);
		});
		stderrStream.on("end", () => {
			if (buffer.trim()) this.#logger.info(`[MCP Server stderr] ${buffer}`);
		});
		stderrStream.on("error", (error) => {
			this.#logger.error("[MCP Server stderr] Stream error", error);
		});
		this.#transportDisposables.add({ dispose: () => stderrStream.removeAllListeners() });
	}
	#handleConnectionLost(reason, error) {
		if (this.#disposed) return;
		if (this.#state.status === ConnectionState.Failed || this.#state.status === ConnectionState.Disconnected) return;
		this.#logger.warn(`Connection lost: ${reason}`);
		if (this.#state.status === ConnectionState.Connected) this.#destroyServerClient();
		const config = "config" in this.#state ? this.#state.config : this.#serverInfo.config;
		this.#setState({
			status: ConnectionState.Failed,
			config,
			error: McpError.connectionFailed(this.#serverName, error || reason),
			failedAt: /* @__PURE__ */ new Date()
		});
	}
	#createServerClient() {
		if (this.#serverClient) {
			this.#logger.warn("Server client already exists, disposing old one");
			this.#destroyServerClient();
		}
		this.#serverClient = new McpClient(this.#sdkClient, this.#serverName, this.#logger);
	}
	#destroyServerClient() {
		if (this.#serverClient) {
			this.#serverClient.dispose();
			this.#serverClient = void 0;
		}
	}
	#setState(newState) {
		const oldStatus = this.#state.status;
		const newStatus = newState.status;
		this.#state = newState;
		this.#logger.debug(`State transition: ${oldStatus} → ${newStatus}`);
		if (oldStatus !== ConnectionState.Connected && newStatus === ConnectionState.Connected) this.#createServerClient();
		else if (oldStatus === ConnectionState.Connected && newStatus !== ConnectionState.Connected) this.#destroyServerClient();
		this.#updateAuthRegistrationFor(newStatus);
		this.#emitStateChange();
	}
	#emitStateChange() {
		this.#eventBus.emit("state_changed", this.#state);
	}
	#handleAuthFlowEvent = (event) => {
		if (event.serverName !== this.#serverName) return;
		this.#logger.debug(`Received auth flow event for server "${this.#serverName}":`, event);
		if (this.#state.status === ConnectionState.Authenticating) this.#setState({
			...this.#state,
			authUrl: event.authUrl
		});
		else this.#pendingAuthFlowUrl = event.authUrl;
	};
	#registerAuthHandler() {
		if (!this.#authRegistered) {
			this.#authFlowController.onAuthFlowStarted(this.#handleAuthFlowEvent);
			this.#authFinalizerRegistry.registerAuthFinalizer(this.#serverName, this);
			this.#authRegistered = true;
			this.#logger.debug("Auth handler registered");
		}
	}
	#unregisterAuthHandler() {
		if (this.#authRegistered) {
			this.#authFlowController.offAuthFlowStarted(this.#handleAuthFlowEvent);
			this.#authFinalizerRegistry.unregisterAuthFinalizer(this.#serverName);
			this.#authRegistered = false;
			this.#logger.debug("Auth handler unregistered");
		}
	}
	#updateAuthRegistrationFor(status) {
		if (status === ConnectionState.Authenticating) this.#registerAuthHandler();
		else if (status === ConnectionState.Connected || status === ConnectionState.Failed) this.#unregisterAuthHandler();
	}
	#swapToNewTransport(newTransport) {
		this.#transportDisposables.dispose();
		this.#transport.close().catch(() => {});
		this.#transport = newTransport;
		this.#setupConnectionMonitoring();
	}
	#connectNewTransport(newTransport) {
		this.#logger.debug("Connecting SDK client to new transport");
		return ResultAsync.fromPromise(this.#sdkClient.connect(newTransport), (e) => McpError.connectionFailed(this.#serverName, e)).map(() => newTransport);
	}
	#handleAuthSuccess(newTransport) {
		this.#swapToNewTransport(newTransport);
		this.#setState({
			status: ConnectionState.Connected,
			config: this.#serverInfo.config,
			connectedAt: /* @__PURE__ */ new Date()
		});
		this.#logger.info("Authentication complete");
	}
	#handleAuthFailure(error) {
		this.#setState({
			status: ConnectionState.Failed,
			config: this.#serverInfo.config,
			error,
			failedAt: /* @__PURE__ */ new Date()
		});
		this.#logger.error(`Authentication failed - error="${error.message}"`, error);
	}
};
//#endregion
//#region src/mcp/auth/storage/types.ts
const Token = z.object({
	access_token: z.string(),
	token_type: z.string().default("Bearer"),
	expires_at: z.number().optional(),
	refresh_token: z.string().optional()
});
const TokenStorage = createInterfaceId("TokenStorage");
const ClientInfo = z.object({
	client_id: z.string(),
	client_secret: z.string().optional()
});
const ClientInfoStorage = createInterfaceId("ClientInfoStorage");
//#endregion
//#region src/mcp/auth/storage/utils.ts
function createStoredToken(tokens) {
	const now = Date.now();
	const expiresAt = tokens.expires_in ? now + tokens.expires_in * 1e3 : void 0;
	return {
		access_token: tokens.access_token,
		token_type: tokens.token_type || "Bearer",
		expires_at: expiresAt,
		refresh_token: tokens.refresh_token
	};
}
//#endregion
//#region src/mcp/auth/storage/errors.ts
const StorageError = {
	notFound: (serverName, storageType) => createError("STORAGE_NOT_FOUND", `${storageType} not found for server: ${serverName}`, {
		serverName,
		storageType
	}),
	validation: (serverName, storageType, issues) => createError("STORAGE_VALIDATION_ERROR", `${storageType} validation failed`, {
		serverName,
		storageType,
		issues
	}),
	io: (serverName, storageType, cause) => createError("STORAGE_IO_ERROR", "Storage I/O failed", {
		serverName,
		storageType,
		cause
	})
};
//#endregion
//#region src/mcp/auth/storage/services/memory.ts
var MemoryAuthStorage = class {
	#byServer = /* @__PURE__ */ new Map();
	#schema;
	#storageType;
	constructor(schema, storageType) {
		this.#schema = schema;
		this.#storageType = storageType;
	}
	store(serverName, data) {
		try {
			const parsed = this.#schema.safeParse(data);
			if (!parsed.success) return errAsync(StorageError.validation(serverName, this.#storageType, parsed.error));
			this.#byServer.set(serverName, { ...parsed.data });
			return okAsync(void 0);
		} catch (cause) {
			return errAsync(StorageError.io(serverName, this.#storageType, cause));
		}
	}
	load(serverName) {
		try {
			const val = this.#byServer.get(serverName);
			if (!val) return errAsync(StorageError.notFound(serverName, this.#storageType));
			return okAsync({ ...val });
		} catch (cause) {
			return errAsync(StorageError.io(serverName, this.#storageType, cause));
		}
	}
	clear(serverName) {
		try {
			this.#byServer.delete(serverName);
			return okAsync(void 0);
		} catch (cause) {
			return errAsync(StorageError.io(serverName, this.#storageType, cause));
		}
	}
};
//#endregion
//#region src/mcp/auth/storage/di.ts
function registerAuthStorageServices(serviceCollection) {
	serviceCollection.add(createFactoryDescriptor({
		aliases: [TokenStorage],
		lifetime: ServiceLifetime.Singleton,
		factory: () => new MemoryAuthStorage(Token, "Token")
	}));
	serviceCollection.add(createFactoryDescriptor({
		aliases: [ClientInfoStorage],
		lifetime: ServiceLifetime.Singleton,
		factory: () => new MemoryAuthStorage(ClientInfo, "ClientInfo")
	}));
	return serviceCollection;
}
//#endregion
//#region src/mcp/auth/callback/types.ts
const McpAuthCallbackUrlProvider = createInterfaceId("AuthCallbackUrlProvider");
//#endregion
//#region src/mcp/auth/provider/errors.ts
const OAuthFactoryError = { callbackServerStartFailed: (cause) => createError("OAUTH_CALLBACK_SERVER_START_FAILED", "Failed to start OAuth callback server", { cause }) };
//#endregion
//#region src/mcp/auth/flow/errors.ts
const AuthFlowError = {
	stateNotFound: () => createError("AUTH_FLOW_STATE_NOT_FOUND", "No OAuth flow is registered for the provided state", {}),
	finalizerNotFound: (serverName) => createError("AUTH_FLOW_FINALIZER_NOT_FOUND", `No OAuth finalizer found for server: ${serverName}`, { serverName }),
	finalizationFailed: (serverName, cause) => createError("AUTH_FLOW_FINALIZATION_FAILED", `OAuth flow finalization failed for server: ${serverName}`, {
		serverName,
		cause
	})
};
//#endregion
//#region src/mcp/auth/flow/types.ts
const McpAuthFinalizerRegistry = createInterfaceId("McpAuthFinalizerRegistry");
const McpAuthFlowController = createInterfaceId("McpAuthFlowController");
//#endregion
//#region src/mcp/auth/flow/services/flow_manager.ts
let _initClass$7;
function _applyDecs$7(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$7(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$7(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$7(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$7(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$7(t) {
	var i = _toPrimitive$7(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$7(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$7(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$7(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const McpAuthFlowManager = createInterfaceId("AuthFlowManager");
let _DefaultMcpAuthFlowMa;
(class {
	static {
		[_DefaultMcpAuthFlowMa, _initClass$7] = _applyDecs$7(this, [Service({
			lifetime: ServiceLifetime.Singleton,
			dependencies: [Logger]
		}), Implements(McpAuthFlowManager)], []).c;
	}
	#flows = /* @__PURE__ */ new Map();
	#finalizers = /* @__PURE__ */ new Map();
	#authFlowHandlers = /* @__PURE__ */ new Set();
	#ttlMs;
	#logger;
	constructor(logger, opts = {}) {
		this.#logger = withPrefix(logger, "[MCP][AuthFlow]");
		this.#ttlMs = Math.max(1e3, opts.ttlMs ?? 3e5);
	}
	registerAuthFinalizer(serverName, finalizer) {
		this.#finalizers.set(serverName, finalizer);
		this.#logger.debug(`Finalizer registered - server="${serverName}"`);
	}
	unregisterAuthFinalizer(serverName) {
		this.#finalizers.delete(serverName);
		this.#logger.debug(`Finalizer unregistered - server="${serverName}"`);
	}
	clearFinalizers() {
		this.#finalizers.clear();
		this.#logger.debug("Finalizers cleared");
	}
	startFlow(serverName) {
		const state = crypto.randomBytes(16).toString("hex");
		const rec = {
			serverName,
			createdAt: Date.now()
		};
		rec.timeout = setTimeout(() => this.#onTimeout(state), this.#ttlMs);
		rec.timeout?.unref();
		this.#flows.set(state, rec);
		this.#logger.debug(`Flow started - server=${serverName}`);
		return state;
	}
	completeFlow(state, code) {
		const rec = this.#flows.get(state);
		if (!rec) {
			this.#logger.debug(`Flow state not found - state=${state}`);
			return errAsync(AuthFlowError.stateNotFound());
		}
		if (rec.done) return ResultAsync.fromSafePromise(Promise.resolve());
		const finalizer = this.#finalizers.get(rec.serverName);
		if (!finalizer) {
			this.#logger.debug(`Finalizer not found - server="${rec.serverName}"`);
			return errAsync(AuthFlowError.finalizerNotFound(rec.serverName));
		}
		rec.done = true;
		this.#clearTimer(rec);
		this.#flows.delete(state);
		return finalizer.finishAuth(code).mapErr((e) => {
			this.#logger.error(`Finalization failed - server="${rec.serverName}"`);
			return AuthFlowError.finalizationFailed(rec.serverName, e);
		});
	}
	clearFlows() {
		for (const [, rec] of this.#flows) this.#clearTimer(rec);
		this.#flows.clear();
	}
	onAuthFlowStarted(handler) {
		this.#authFlowHandlers.add(handler);
		this.#logger.debug("Auth flow handler registered");
	}
	offAuthFlowStarted(handler) {
		this.#authFlowHandlers.delete(handler);
		this.#logger.debug("Auth flow handler unregistered");
	}
	/**
	* Notify all subscribers that an auth flow has started with an authorization URL
	* This is called by the OAuth provider when redirecting to authorization
	*/
	notifyAuthFlowStarted(serverName, authUrl, state) {
		const event = {
			serverName,
			authUrl,
			state
		};
		this.#logger.debug(`Notifying auth flow started - server=${serverName} state=${state}`);
		for (const handler of this.#authFlowHandlers) try {
			handler(event);
		} catch (error) {
			this.#logger.error(`Auth flow handler error - server=${serverName}`, error);
		}
	}
	#clearTimer(rec) {
		if (rec.timeout) {
			clearTimeout(rec.timeout);
			rec.timeout = void 0;
		}
	}
	#onTimeout(state) {
		const rec = this.#flows.get(state);
		if (!rec || rec.done) return;
		rec.done = true;
		this.#clearTimer(rec);
		this.#flows.delete(state);
		const finalizer = this.#finalizers.get(rec.serverName);
		if (!finalizer) {
			this.#logger.debug(`Flow timeout but no finalizer registered - server="${rec.serverName}"`);
			return;
		}
		this.#logger.debug(`Flow timeout notifying finalizer - server="${rec.serverName}"`);
		finalizer.finishAuth(null).mapErr(() => void 0).unwrapOr(void 0).catch(() => void 0);
	}
	static {
		_initClass$7();
	}
});
//#endregion
//#region src/mcp/auth/flow/di.ts
function registerMcpAuthFlowServices(serviceCollection) {
	serviceCollection.addClass(_DefaultMcpAuthFlowMa);
	serviceCollection.add(createFactoryDescriptor({
		aliases: [McpAuthFinalizerRegistry],
		lifetime: ServiceLifetime.Singleton,
		factory: (ctx) => {
			return ctx.getRequiredService(McpAuthFlowManager);
		}
	}));
	serviceCollection.add(createFactoryDescriptor({
		aliases: [McpAuthFlowController],
		lifetime: ServiceLifetime.Singleton,
		factory: (ctx) => {
			return ctx.getRequiredService(McpAuthFlowManager);
		}
	}));
}
//#endregion
//#region src/mcp/auth/callback/callback_server.ts
/** Shape returned by the JSON API */
function authFlowErrorToHttpStatus(e) {
	switch (e.code) {
		case "AUTH_FLOW_STATE_NOT_FOUND": return 400;
		case "AUTH_FLOW_FINALIZER_NOT_FOUND":
		case "AUTH_FLOW_FINALIZATION_FAILED": return 500;
		default: return 500;
	}
}
/**
* Create and configure the Fastify server with OAuth callback routes
*/
async function createServer(flowManager, logger, callbackPath, rateLimit) {
	const log = withPrefix(logger, "[MCP][OAuthCallback]");
	const server = Fastify({ logger: false });
	await server.register(FastifyRateLimit, {
		global: false,
		...rateLimit
	});
	server.addHook("onSend", (_req, reply, payload, done) => {
		reply.header("x-frame-options", "DENY").header("x-content-type-options", "nosniff").header("referrer-policy", "no-referrer").header("cache-control", "no-store").header("content-security-policy", "default-src 'none'; frame-ancestors 'none'; base-uri 'none'");
		done(null, payload);
	});
	server.get("/health", async () => ({ status: "ok" }));
	server.get(callbackPath, { preHandler: server.rateLimit() }, async (request, reply) => {
		const { code, state, error, error_description: errorDescription } = request.query;
		if (error) {
			log.error(`authorize_error type=${error}`);
			return reply.code(400).send({
				status: "error",
				error: {
					code: "OAUTH_AUTHORIZATION_ERROR",
					message: errorDescription ?? error
				}
			});
		}
		if (!code || !state) {
			log.error("invalid_request: missing code or state");
			return reply.code(400).send({
				status: "error",
				error: {
					code: "INVALID_REQUEST",
					message: "Missing required parameters"
				}
			});
		}
		const result = await flowManager.completeFlow(state, code);
		if (result.isOk()) {
			log.info("flow_completed");
			return reply.code(200).send({ status: "success" });
		}
		const http = authFlowErrorToHttpStatus(result.error);
		log.error(`flow_failed code=${result.error.code} msg=${result.error.message}`);
		return reply.code(http).send({
			status: "error",
			error: {
				code: result.error.code,
				message: result.error.message
			}
		});
	});
	return server;
}
var OAuthCallbackServer = class OAuthCallbackServer {
	#server;
	#logger;
	#disposed = false;
	#callbackUrl;
	constructor(server, logger, hostname, callbackPath) {
		this.#server = server;
		this.#logger = withPrefix(logger, "[MCP][OAuthCallback]");
		const address = server.server.address();
		if (!address || typeof address === "string") throw new Error("Failed to get server address");
		this.#callbackUrl = new URL(`http://${hostname}:${address.port}${callbackPath}`);
	}
	get callbackUrl() {
		return this.#callbackUrl;
	}
	static async create(flowManager, logger, options = {}) {
		const hostname = options.hostname ?? "127.0.0.1";
		const callbackPath = options.callbackPath ?? "/callback";
		const port = options.port ?? 0;
		const server = await createServer(flowManager, logger, callbackPath, {
			timeWindow: options.rateLimit?.timeWindow ?? 6e4,
			max: options.rateLimit?.max ?? 30
		});
		await server.listen({
			port,
			host: hostname
		});
		const addr = server.server.address();
		const actual = typeof addr === "string" ? addr : addr?.port;
		withPrefix(logger, "[MCP][OAuthCallback]").info(`server_started host=${addr} port=${actual}`);
		if (!new Set([
			"127.0.0.1",
			"::1",
			"localhost"
		]).has(hostname)) withPrefix(logger, "[MCP][OAuthCallback]").warn(`non_loopback_binding host=${hostname} - ensure this is intentional and TLS is terminated upstream`);
		return new OAuthCallbackServer(server, logger, hostname, callbackPath);
	}
	dispose() {
		if (this.#disposed) return;
		this.#disposed = true;
		this.#server.close().then(() => this.#logger.info("server_stopped"), (err) => this.#logger.error("server_close_error", err)).catch((err) => this.#logger.error("server_dispose_uncaught", err));
	}
	isDisposed() {
		return this.#disposed;
	}
};
//#endregion
//#region src/mcp/auth/callback/service.ts
let _initClass$6;
function _applyDecs$6(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$6(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$6(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$6(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$6(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$6(t) {
	var i = _toPrimitive$6(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$6(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$6(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$6(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _AuthCallbackService;
(class {
	static {
		[_AuthCallbackService, _initClass$6] = _applyDecs$6(this, [Service({
			lifetime: ServiceLifetime.Singleton,
			dependencies: [McpAuthFlowController, Logger]
		}), Implements(McpAuthCallbackUrlProvider)], []).c;
	}
	#flow;
	#logger;
	#server = null;
	#url = null;
	constructor(flow, logger) {
		this.#flow = flow;
		this.#logger = withPrefix(logger, "[MCP][AuthCallbackService]");
	}
	getCallbackUrl() {
		if (this.#url) return okAsync(this.#url);
		return ResultAsync.fromPromise(OAuthCallbackServer.create(this.#flow, this.#logger, {}), (e) => OAuthFactoryError.callbackServerStartFailed(e)).map((callbackServer) => {
			this.#server = callbackServer;
			this.#url = callbackServer.callbackUrl;
			this.#logger.info(`server_started origin=${this.#url.origin}`);
			return callbackServer.callbackUrl;
		}).orTee((e) => {
			this.#logger.debug(e.message, e.cause);
		});
	}
	dispose() {
		this.#server?.dispose();
	}
	static {
		_initClass$6();
	}
});
//#endregion
//#region src/mcp/auth/callback/di.ts
function registerMcpAuthCallbackServices(serviceCollection) {
	serviceCollection.addClass(_AuthCallbackService);
}
//#endregion
//#region src/mcp/url_opener_service.ts
const WorkflowUrlOpenerService = createInterfaceId("WorkflowUrlOpenerService");
//#endregion
//#region src/mcp/auth/provider/services/oauth_client_provider.ts
const TOKEN_EXPIRY_SKEW_MS = 3e4;
var OAuthProviderError = class extends Error {
	constructor(code, message, cause) {
		super(message);
		this.name = "OAuthProviderError";
		this.code = code;
		this.cause = cause;
	}
};
var DefaultOAuthClientProvider = class {
	#name;
	#serverConfig;
	#logger;
	#urlOpenerService;
	#tokenStorage;
	#clientInfoStorage;
	#authFlowController;
	#codeVerifier;
	#currentState;
	#redirectUrl;
	constructor(serverInfo, urlOpenerService, tokenStorage, clientInfoStorage, authFlowController, logger, redirectUrl) {
		this.#name = serverInfo.name;
		this.#serverConfig = serverInfo.config;
		this.#urlOpenerService = urlOpenerService;
		this.#tokenStorage = tokenStorage;
		this.#clientInfoStorage = clientInfoStorage;
		this.#authFlowController = authFlowController;
		this.#logger = withPrefix(logger, `[MCP][OAuth][${this.#name}]`);
		if (!redirectUrl) throw new OAuthProviderError("OAUTH_MISSING_REDIRECT_URL", "redirectUrl is required for OAuth flow");
		this.#redirectUrl = redirectUrl;
	}
	get redirectUrl() {
		return this.#redirectUrl;
	}
	get clientMetadata() {
		return {
			client_name: `GitLab Language Server - ${this.#name}`,
			redirect_uris: [this.#redirectUrl.toString()],
			scope: this.#serverConfig.oauth2?.scopes?.join(" "),
			grant_types: ["authorization_code", "refresh_token"],
			response_types: ["code"],
			token_endpoint_auth_method: "none"
		};
	}
	async clientInformation() {
		if (this.#serverConfig.oauth2?.clientId) return {
			client_id: this.#serverConfig.oauth2.clientId,
			client_secret: this.#serverConfig.oauth2.clientSecret
		};
		return (await this.#clientInfoStorage.load(this.#name)).map((x) => ({
			client_id: x.client_id,
			client_secret: x.client_secret
		})).orTee((e) => {
			if (e.code === "STORAGE_NOT_FOUND") this.#logger.debug("client_info: none found");
			else this.#logger.error(`client_info: load_failed code=${e.code}`);
		}).unwrapOr(void 0);
	}
	async saveClientInformation(clientInfo) {
		this.#logger.info("client_info: saving");
		const storedClientInfo = {
			client_id: clientInfo.client_id,
			client_secret: clientInfo.client_secret
		};
		const res = await this.#clientInfoStorage.store(this.#name, storedClientInfo);
		if (res.isErr()) {
			this.#logger.error(`client_info: save_failed code=${res.error.code}`);
			throw new OAuthProviderError("OAUTH_STORAGE_SAVE_FAILED", "Failed to save OAuth client information", res.error);
		}
	}
	async tokens() {
		return (await this.#tokenStorage.load(this.#name)).map((token) => {
			if (!token.access_token) return void 0;
			const now = Date.now();
			const expired = token.expires_at && now >= token.expires_at - TOKEN_EXPIRY_SKEW_MS;
			return {
				access_token: token.access_token,
				token_type: token.token_type,
				refresh_token: token.refresh_token,
				expires_in: expired ? 0 : token.expires_at ? Math.floor((token.expires_at - now) / 1e3) : void 0
			};
		}).orTee((e) => {
			if (e.code === "STORAGE_NOT_FOUND") this.#logger.debug("tokens: none found");
			else this.#logger.error(`tokens: load_failed code=${e.code}`);
		}).unwrapOr(void 0);
	}
	async saveTokens(tokens) {
		this.#logger.info("tokens: saving");
		const storedToken = createStoredToken(tokens);
		const res = await this.#tokenStorage.store(this.#name, storedToken);
		if (res.isErr()) {
			this.#logger.error(`tokens: save_failed code=${res.error.code}`);
			throw new OAuthProviderError("OAUTH_STORAGE_SAVE_FAILED", "Failed to save OAuth tokens", res.error);
		}
	}
	async redirectToAuthorization(authorizationUrl) {
		this.#logger.info(`authorize: opening_browser issuer=${authorizationUrl.origin}`);
		if (this.#currentState) this.#authFlowController.notifyAuthFlowStarted(this.#name, authorizationUrl.toString(), this.#currentState);
		await this.#urlOpenerService.openUrl(authorizationUrl.toString());
	}
	async saveCodeVerifier(codeVerifier) {
		this.#codeVerifier = codeVerifier;
	}
	async codeVerifier() {
		if (!this.#codeVerifier) throw new OAuthProviderError("OAUTH_MISSING_CODE_VERIFIER", "No code verifier saved");
		return this.#codeVerifier;
	}
	async state() {
		const state = this.#authFlowController.startFlow(this.#name);
		this.#currentState = state;
		this.#logger.debug("state: generated");
		return state;
	}
};
//#endregion
//#region src/mcp/auth/provider/services/oauth_client_provider_factory.ts
let _initClass$5;
function _applyDecs$5(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$5(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$5(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$5(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$5(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$5(t) {
	var i = _toPrimitive$5(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$5(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$5(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$5(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const OAuthClientProviderFactory = createInterfaceId("OAuthClientProviderFactory");
let _DefaultOAuthClientPr;
(class {
	static {
		[_DefaultOAuthClientPr, _initClass$5] = _applyDecs$5(this, [Service({
			lifetime: ServiceLifetime.Singleton,
			dependencies: [
				McpAuthFlowController,
				WorkflowUrlOpenerService,
				TokenStorage,
				ClientInfoStorage,
				McpAuthCallbackUrlProvider,
				Logger
			]
		}), Implements(OAuthClientProviderFactory)], []).c;
	}
	#urlOpener;
	#tokenStorage;
	#clientInfoStorage;
	#authCallbackUrlProvider;
	#authFlowManager;
	#logger;
	#log;
	constructor(authFlowManager, urlOpener, tokenStorage, clientInfoStorage, authCallbackUrlProvider, logger) {
		this.#authFlowManager = authFlowManager;
		this.#urlOpener = urlOpener;
		this.#tokenStorage = tokenStorage;
		this.#clientInfoStorage = clientInfoStorage;
		this.#authCallbackUrlProvider = authCallbackUrlProvider;
		this.#logger = logger;
		this.#log = withPrefix(logger, "[MCP][OAuthFactory]");
	}
	createOAuthClientProvider(serverInfo) {
		return this.#authCallbackUrlProvider.getCallbackUrl().map((callbackUrl) => {
			return new DefaultOAuthClientProvider(serverInfo, this.#urlOpener, this.#tokenStorage, this.#clientInfoStorage, this.#authFlowManager, this.#logger, callbackUrl);
		}).andTee(() => {
			this.#log.debug(`provider: created for=${serverInfo.name}`);
		}).orTee((e) => {
			this.#log.error(`provider: failed for=${serverInfo.name} code=${e.code} msg=${e.message}`, e.cause);
		});
	}
	static {
		_initClass$5();
	}
});
//#endregion
//#region src/mcp/auth/provider/di.ts
function registerMcpAuthProviderServices(serviceCollection) {
	serviceCollection.addClass(_DefaultOAuthClientPr);
}
//#endregion
//#region src/mcp/auth/di.ts
function registerMcpAuthServices(serviceCollection) {
	registerAuthStorageServices(serviceCollection);
	registerMcpAuthFlowServices(serviceCollection);
	registerMcpAuthCallbackServices(serviceCollection);
	registerMcpAuthProviderServices(serviceCollection);
}
//#endregion
//#region src/mcp/client/transport/error.ts
const TransportError = {
	invalidConfig: (serverName, reason) => createError("TRANSPORT_INVALID_CONFIG", `Invalid transport config for ${serverName}: ${reason}`, {
		serverName,
		reason
	}),
	creationFailed: (serverName, transportType, cause) => createError("TRANSPORT_CREATION_FAILED", `Failed to create ${transportType} transport for ${serverName}`, {
		serverName,
		transportType,
		cause
	}),
	invalidUrl: (serverName, url) => createError("TRANSPORT_INVALID_URL", `Invalid URL for ${serverName}: ${url}`, {
		serverName,
		url
	})
};
//#endregion
//#region src/mcp/client/transport/transport_factory.ts
let _initClass$4;
function _applyDecs$4(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$4(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$4(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$4(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$4(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$4(t) {
	var i = _toPrimitive$4(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$4(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$4(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$4(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _TransportFactory;
(class {
	static {
		[_TransportFactory, _initClass$4] = _applyDecs$4(this, [Service({
			dependencies: [
				OAuthClientProviderFactory,
				LsFetch,
				McpStdioCommandTransformer
			],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#authProviderFactory;
	#lsFetch;
	#stdioTransformer;
	constructor(authProviderFactory, lsFetch, stdioTransformer) {
		this.#authProviderFactory = authProviderFactory;
		this.#lsFetch = lsFetch;
		this.#stdioTransformer = stdioTransformer;
	}
	/**
	* Creates a transport for the given server.
	* @param serverInfo - The server configuration.
	* @param workspacePath - Absolute path to the workspace root.
	*   TODO: Move this to a provider for DI instead of passing as a string argument.
	*/
	createTransport(serverInfo, workspacePath) {
		switch (serverInfo.config.type) {
			case "stdio": {
				if (!serverInfo.config.command) return errAsync(TransportError.invalidConfig(serverInfo.name, "Missing `command` for stdio transport"));
				const { config } = serverInfo;
				const args = config.args ?? [];
				return ResultAsync.fromPromise(this.#stdioTransformer.transform(serverInfo.name, {
					command: config.command,
					args,
					env: config.env
				}, workspacePath, config.sandbox), (e) => TransportError.creationFailed(serverInfo.name, "stdio", e)).map((params) => new StdioClientTransport({
					command: params.command,
					args: params.args,
					env: params.env,
					cwd: config.cwd ?? workspacePath,
					stderr: "pipe"
				}));
			}
			case "sse": {
				const { config } = serverInfo;
				return this.#authProviderFactory.createOAuthClientProvider(serverInfo).mapErr((e) => TransportError.creationFailed(serverInfo.name, serverInfo.config.type, e)).andThen((authProvider) => okAsync(new SSEClientTransport(config.url, {
					authProvider,
					fetch: (url, init) => this.#lsFetch.fetchBase(url, init),
					requestInit: config.headers ? { headers: config.headers } : void 0
				})));
			}
			case "http": {
				const { config } = serverInfo;
				return this.#authProviderFactory.createOAuthClientProvider(serverInfo).mapErr((e) => TransportError.creationFailed(serverInfo.name, serverInfo.config.type, e)).andThen((authProvider) => okAsync(new StreamableHTTPClientTransport(config.url, {
					authProvider,
					fetch: (url, init) => this.#lsFetch.fetchBase(url, init),
					requestInit: config.headers ? { headers: config.headers } : void 0
				})));
			}
			default: return errAsync(TransportError.invalidConfig(serverInfo.name, `Unsupported transport type: ${serverInfo.config.type}`));
		}
	}
	static {
		_initClass$4();
	}
});
//#endregion
//#region src/mcp/client/transport/provider.ts
const boundProvider = (mk) => ({ create: mk });
//#endregion
//#region src/mcp/client/connection_factory.ts
let _initClass$3;
function _applyDecs$3(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$3(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$3(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$3(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$3(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$3(t) {
	var i = _toPrimitive$3(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$3(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$3(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$3(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _McpConnectionFactory;
(class {
	static {
		[_McpConnectionFactory, _initClass$3] = _applyDecs$3(this, [Service({
			lifetime: ServiceLifetime.Singleton,
			dependencies: [
				_TransportFactory,
				McpAuthFlowController,
				McpAuthFinalizerRegistry,
				Logger
			]
		})], []).c;
	}
	#transportFactory;
	#authFlowController;
	#authFinalizerRegistry;
	#logger;
	constructor(transportFactory, authFlowController, authFinalizerRegistry, logger) {
		this.#transportFactory = transportFactory;
		this.#authFlowController = authFlowController;
		this.#authFinalizerRegistry = authFinalizerRegistry;
		this.#logger = withPrefix(logger, "[MCP][ServerConnectionFactory]");
	}
	/**
	* Build an MCP client and attempt the initial connection.
	* Returns connected/authenticating connection, or error on failure.
	*/
	connect(server, workspacePath) {
		this.#logger.debug(`Creating client - server="${server.name}" type="${server.config.type}"`);
		const sdkClient = new Client({
			name: "gitlab-language-server",
			version: "1.0.0"
		});
		const transportProvider = boundProvider(() => this.#transportFactory.createTransport(server, workspacePath));
		return transportProvider.create().mapErr((e) => McpError.transportCreationFailed(server.name, server.config.type, e)).andThen((transport) => {
			const connection = new DefaultMcpConnection(sdkClient, transport, transportProvider, server, this.#logger, this.#authFlowController, this.#authFinalizerRegistry);
			return connection.attemptConnect().map(() => connection);
		});
	}
	static {
		_initClass$3();
	}
});
//#endregion
//#region src/mcp/client/di.ts
function registerMcpClientServices(serviceCollection) {
	serviceCollection.addClass(_TransportFactory);
	serviceCollection.addClass(_McpConnectionFactory);
	return serviceCollection;
}
//#endregion
//#region src/mcp/server_session_manager.ts
function enhanceConnectionState(base, extras) {
	return {
		...base,
		...extras
	};
}
/**
* McpServerSessionManager
*
* Manages the lifecycle of a single MCP server session bound to a (possibly changing)
* configuration. It:
*  - parses and hashes config for change detection
*  - creates/tears down an McpConnection via factory
*  - translates raw connection snapshots into richer server snapshots
*  - exposes convenience ops (getTools/executeTool)
*
* Auth flow orchestration lives inside McpConnection.
*/
var McpServerSessionManager = class {
	#serverName;
	#displayName;
	#workspacePath;
	#connectionFactory;
	#logger;
	#state = { status: ConnectionState.Disconnected };
	#connection;
	#currentConfig;
	#configHash;
	#toolCount = 0;
	#gen = 0;
	#stateHandlers = /* @__PURE__ */ new Set();
	#connectionUnsubscribe;
	constructor(serverName, displayName, initialConfig, workspacePath, connectionFactory, logger) {
		this.#serverName = serverName;
		this.#displayName = displayName;
		this.#workspacePath = workspacePath;
		this.#connectionFactory = connectionFactory;
		this.#logger = withPrefix(logger, `[MCP][ServerSessionManager][${displayName}]`);
		const parseResult = this.#parseAndHashConfig(initialConfig);
		if (parseResult.success) {
			this.#currentConfig = parseResult.config;
			this.#configHash = parseResult.hash;
		} else {
			this.#logger.error(`Initial config parse failed: ${parseResult.error}`);
			this.#state = {
				status: ConnectionState.Failed,
				error: parseResult.error,
				failedAt: /* @__PURE__ */ new Date()
			};
		}
	}
	get serverName() {
		return this.#serverName;
	}
	get currentConfig() {
		return this.#currentConfig;
	}
	get currentConfigHash() {
		return this.#configHash;
	}
	/**
	* Get current server state snapshot.
	*/
	getState() {
		return this.#state;
	}
	/**
	* Get the connected client for operations.
	*/
	#getConnectedClient() {
		if (!this.#connection) return errAsync(McpError.connectionFailed(this.#serverName, "No connection established"));
		return this.#connection.getConnectedClient();
	}
	/**
	* Get cached tools (updated automatically when connected).
	*/
	getTools() {
		return this.#getConnectedClient().andThen((client) => client.getTools());
	}
	/**
	* Execute a tool on the server.
	*/
	executeTool(toolName, args) {
		return this.#getConnectedClient().andThen((client) => client.executeTool(toolName, args));
	}
	/**
	* Mark this session as pending user approval.
	* Any active connection is torn down so the server cannot be used until
	* the user approves again — this is the correct behaviour for both initial
	* pending state and for revocation of a previously-approved server.
	*/
	setPendingApproval() {
		if (!this.#currentConfig || !this.#configHash) {
			this.#logger.error("Cannot set pending approval - no valid config");
			return;
		}
		this.#disposeConnection();
		this.#toolCount = 0;
		this.#setState({
			status: ConnectionState.PendingApproval,
			config: this.#currentConfig,
			configHash: this.#configHash
		});
	}
	/**
	* Apply new configuration and immediately mark the session as pending approval,
	* without starting a connection. Use this when the config has changed but the
	* new config has not yet been approved by the user.
	*
	* Unlike `setPendingApproval()`, which always tears down the active connection,
	* this only disposes the connection when the config hash actually changes. If the
	* config is unchanged the existing connection is left intact while the state moves
	* to PendingApproval. In practice the manager only calls this on a config change,
	* so the connection is always disposed.
	*/
	applyConfigPendingApproval(rawConfig) {
		const parseResult = this.#parseAndHashConfig(rawConfig);
		if (!parseResult.success) {
			this.#logger.error(`Config parse failed: ${parseResult.error}`);
			return;
		}
		if (this.#configHash !== parseResult.hash) {
			this.#disposeConnection();
			this.#currentConfig = parseResult.config;
			this.#configHash = parseResult.hash;
			this.#toolCount = 0;
		}
		if (!this.#currentConfig || !this.#configHash) {
			this.#logger.error("Cannot set pending approval - no valid config after update");
			return;
		}
		this.#setState({
			status: ConnectionState.PendingApproval,
			config: this.#currentConfig,
			configHash: this.#configHash
		});
	}
	/**
	* Mark this session as rejected by the user.
	* Any active connection is torn down so the server cannot be used.
	*/
	setRejected() {
		if (!this.#currentConfig || !this.#configHash) {
			this.#logger.error("Cannot set rejected - no valid config");
			return;
		}
		this.#disposeConnection();
		this.#toolCount = 0;
		this.#setState({
			status: ConnectionState.Rejected,
			config: this.#currentConfig,
			configHash: this.#configHash
		});
	}
	/**
	* Start the connection (initial connect).
	* Also valid when transitioning from PendingApproval or Rejected states.
	*/
	async start() {
		if (this.#state.status === ConnectionState.Connecting || this.#state.status === ConnectionState.Connected) return;
		if (!this.#currentConfig) {
			this.#logger.error("Cannot start - no valid config");
			this.#setState({
				status: ConnectionState.Failed,
				error: "Invalid configuration",
				failedAt: /* @__PURE__ */ new Date()
			});
			return;
		}
		await this.#connect();
	}
	async reconnect() {
		if (!this.#currentConfig || !this.#configHash) {
			const error = "Cannot reconnect - no valid config";
			this.#logger.error(error);
			this.#setState({
				status: ConnectionState.Failed,
				error,
				failedAt: /* @__PURE__ */ new Date()
			});
			throw new Error(error);
		}
		this.#disposeConnection();
		this.#setState({ status: ConnectionState.Disconnected });
		try {
			await this.#connect();
		} catch (error) {
			this.#logger.error("Reconnect failed", error);
			throw error;
		}
	}
	/**
	* Apply new configuration:
	* - deep-canonical hash for change detection
	* - if changed, tears down and reconnects
	* - if unchanged, no-op
	*/
	async applyConfig(rawConfig) {
		const parseResult = this.#parseAndHashConfig(rawConfig);
		if (!parseResult.success) {
			this.#logger.error(`Config parse failed: ${parseResult.error}`);
			return {
				changed: false,
				parseError: parseResult.error
			};
		}
		if (this.#configHash === parseResult.hash) return { changed: false };
		this.#logger.info("Config changed - reconnecting");
		this.#disposeConnection();
		this.#currentConfig = parseResult.config;
		this.#configHash = parseResult.hash;
		this.#toolCount = 0;
		await this.#connect();
		return { changed: true };
	}
	/**
	* Complete OAuth authentication (proxied to McpConnection).
	*/
	finishAuth(code) {
		if (!this.#connection) return errAsync(McpError.connectionFailed(this.#serverName, "No connection to authenticate"));
		return this.#connection.finishAuth(code);
	}
	/**
	* Subscribe to state changes.
	* @returns Unsubscribe function
	*/
	onStateChanged(handler) {
		this.#stateHandlers.add(handler);
		return () => this.#stateHandlers.delete(handler);
	}
	/**
	* Dispose and cleanup.
	*/
	dispose() {
		this.#disposeConnection();
		this.#setState({ status: ConnectionState.Disconnected });
		this.#stateHandlers.clear();
		this.#currentConfig = void 0;
		this.#configHash = void 0;
		this.#toolCount = 0;
	}
	/**
	* Parse and deep-hash config for change detection.
	*/
	#parseAndHashConfig(rawConfig) {
		try {
			const parsed = ServerConfig.safeParse(rawConfig);
			if (!parsed.success) return {
				success: false,
				error: `Invalid config: ${parsed.error.message}`
			};
			const config = parsed.data;
			return {
				success: true,
				config,
				hash: hashServerConfig(config)
			};
		} catch (error) {
			return {
				success: false,
				error: error instanceof Error ? error.message : "Config parse failed"
			};
		}
	}
	/**
	* Establish connection to the server with race hardening.
	*/
	async #connect() {
		if (!this.#currentConfig || !this.#configHash) {
			const error = "Cannot connect - no valid config";
			this.#logger.error(error);
			this.#setState({
				status: ConnectionState.Failed,
				error,
				failedAt: /* @__PURE__ */ new Date()
			});
			throw new Error(error);
		}
		const myGen = ++this.#gen;
		this.#setState({
			status: ConnectionState.Connecting,
			config: this.#currentConfig,
			configHash: this.#configHash,
			startedAt: /* @__PURE__ */ new Date()
		});
		this.#logger.debug("Connecting...");
		const serverInfo = {
			name: this.#serverName,
			displayName: this.#displayName,
			config: this.#currentConfig
		};
		await this.#connectionFactory.connect(serverInfo, this.#workspacePath).andTee((connection) => {
			if (this.#gen !== myGen) {
				connection.dispose();
				return;
			}
			this.#connection = connection;
			this.#setupConnectionHandlers(connection);
			const currentState = connection.getStateSnapshot();
			this.#enhanceAndEmitState(currentState);
		}).orTee((error) => {
			if (this.#gen !== myGen) return;
			this.#logger.error(`Connection failed: ${error.message}`);
			this.#setState({
				status: ConnectionState.Failed,
				config: this.#currentConfig,
				configHash: this.#configHash,
				error: error.message,
				failedAt: /* @__PURE__ */ new Date()
			});
		}).match(() => {}, () => {});
	}
	/**
	* Setup handlers to bridge connection events to server events.
	*/
	#setupConnectionHandlers(connection) {
		this.#connectionUnsubscribe?.();
		this.#connectionUnsubscribe = connection.onStateChanged((connState) => {
			if (connState.status === ConnectionState.Connected) this.#populateToolCountOnce(connState);
			this.#enhanceAndEmitState(connState);
		});
	}
	/**
	* On first Connected, fetch tools to populate toolCount and re-emit snapshot.
	*/
	#populateToolCountOnce(connState) {
		if (this.#toolCount > 0) return;
		this.#getConnectedClient().andThen((client) => client.getTools()).map((tools) => tools.length).match((count) => {
			if (typeof count === "number" && count !== this.#toolCount) {
				this.#toolCount = count;
				this.#enhanceAndEmitState(connState);
			}
		}, () => void 0).catch(() => {});
	}
	/**
	* Enhance connection state with server context and emit.
	*/
	#enhanceAndEmitState(connectionState) {
		const serverState = this.#enhanceConnectionState(connectionState);
		this.#setState(serverState);
	}
	#enhanceConnectionState(conn) {
		switch (conn.status) {
			case ConnectionState.Connecting: return enhanceConnectionState(conn, { configHash: this.#configHash ?? "" });
			case ConnectionState.Authenticating: return enhanceConnectionState(conn, { configHash: this.#configHash ?? "" });
			case ConnectionState.Connected: return enhanceConnectionState(conn, {
				configHash: this.#configHash ?? "",
				toolCount: this.#toolCount
			});
			case ConnectionState.Failed: return enhanceConnectionState(conn, {
				configHash: this.#configHash,
				error: conn.error.message
			});
			case ConnectionState.Disconnected: return enhanceConnectionState(conn, {});
			case ConnectionState.PendingApproval: return enhanceConnectionState(conn, {});
			case ConnectionState.Rejected: return enhanceConnectionState(conn, {});
			default: return conn;
		}
	}
	/**
	* Dispose current connection.
	*/
	#disposeConnection() {
		if (!this.#connection) return;
		this.#connectionUnsubscribe?.();
		this.#connectionUnsubscribe = void 0;
		this.#logger.debug("Disposing connection");
		this.#connection.dispose();
		this.#connection = void 0;
	}
	/**
	* Set state and emit to all handlers.
	*/
	#setState(state) {
		const stableStates = new Set([
			ConnectionState.Disconnected,
			ConnectionState.PendingApproval,
			ConnectionState.Rejected
		]);
		if (this.#state.status === state.status && stableStates.has(state.status)) return;
		const oldStatus = this.#state.status;
		this.#state = state;
		this.#logger.debug(`State: ${oldStatus} → ${state.status}`);
		for (const handler of this.#stateHandlers) try {
			handler(state);
		} catch (error) {
			this.#logger.error("State handler error", error);
		}
	}
};
//#endregion
//#region src/mcp/server_session_manager_factory.ts
let _initClass$2;
function _applyDecs$2(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$2(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$2(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$2(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$2(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$2(t) {
	var i = _toPrimitive$2(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$2(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$2(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$2(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
let _McpServerSessionMana;
(class {
	static {
		[_McpServerSessionMana, _initClass$2] = _applyDecs$2(this, [Service({
			lifetime: ServiceLifetime.Singleton,
			dependencies: [_McpConnectionFactory, Logger]
		})], []).c;
	}
	#connFactory;
	#logger;
	constructor(connFactory, logger) {
		this.#connFactory = connFactory;
		this.#logger = logger;
	}
	create(serverName, displayName, initialConfig, workspacePath) {
		return new McpServerSessionManager(serverName, displayName, initialConfig, workspacePath, this.#connFactory, this.#logger);
	}
	static {
		_initClass$2();
	}
});
//#endregion
//#region src/mcp/manager.ts
let _initClass$1;
function _applyDecs$1(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName$1(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName$1(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey$1(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS$1(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey$1(t) {
	var i = _toPrimitive$1(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive$1(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName$1(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS$1(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const levelToMethod = {
	[LogLevel.Error]: "error",
	[LogLevel.Warning]: "warn",
	[LogLevel.Info]: "info",
	[LogLevel.Debug]: "debug"
};
/**
* Fleet-level MCP Manager
* - Orchestrates per-server sessions (add/update/remove) from configuration
* - Forwards state & log events
* - Routes tool listing/execution & approvals
*/
let _McpManager;
(class {
	static {
		[_McpManager, _initClass$1] = _applyDecs$1(this, [Service({
			dependencies: [
				Logger,
				McpConfigResolver,
				_McpServerSessionMana,
				McpToolSessionApprovalStore,
				McpServerApprovalStore,
				McpApprovalPolicy,
				collection(McpConfigPathProvider)
			],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#logger;
	#configResolver;
	#mcpServerSessionManagerFactory;
	#approvalStore;
	#serverApprovalStore;
	#approvalPolicy;
	#configPathProviders;
	#configSources = [];
	#sessions = /* @__PURE__ */ new Map();
	#executionHistory = [];
	#logs = [];
	#logIdCounter = 0;
	#eventEmitter = new EventEmitter();
	#workspacePath;
	#serversOrigin;
	#reloadSettledWaiters = [];
	#hasCompletedReload = false;
	constructor(logger, configResolver, mcpServerSessionManagerFactory, approvalStore, serverApprovalStore, approvalPolicy, configPathProviders = []) {
		this.#logger = logger;
		this.#configResolver = configResolver;
		this.#mcpServerSessionManagerFactory = mcpServerSessionManagerFactory;
		this.#approvalStore = approvalStore;
		this.#serverApprovalStore = serverApprovalStore;
		this.#approvalPolicy = approvalPolicy;
		this.#configPathProviders = configPathProviders;
	}
	async dispose() {
		this.#logger.info("[MCP Manager] Disposing service");
		await Promise.all([...this.#sessions.values()].map((s) => s.dispose()));
		this.#sessions.clear();
		this.#logs = [];
		this.#executionHistory = [];
		this.#eventEmitter.removeAllListeners();
	}
	/**
	* Config files the last load drew from, contributed ones included. Empty until a
	* load has run, so callers that need the built-ins regardless should fall back to
	* `getMcpConfigPathCandidates`.
	*/
	getConfigSources() {
		return this.#configSources;
	}
	async getServers() {
		return [...this.#sessions.keys()].map((name) => this.#getServerState(name));
	}
	async getServer(serverName) {
		return this.#sessions.get(serverName) ? this.#getServerState(serverName) : null;
	}
	async restartServer(serverName) {
		this.#logger.info(`[MCP Manager] Restarting server: ${serverName}`);
		const s = this.#sessions.get(serverName);
		if (!s) {
			this.#logger.warn(`[MCP Manager] Server not found: ${serverName}`);
			return;
		}
		try {
			await s.reconnect();
		} catch (error) {
			this.#logger.error(`Failed to restart ${serverName}`, error);
			throw error;
		}
	}
	async restartAllServers() {
		this.#logger.info("[MCP Manager] Restarting all servers");
		(await Promise.allSettled([...this.#sessions.values()].map((session) => session.reconnect()))).forEach((result, idx) => {
			if (result.status === "rejected") {
				const serverName = [...this.#sessions.keys()][idx];
				this.#logger.error(`Failed to restart ${serverName}`, result.reason);
			}
		});
	}
	#getServerScope(serverName) {
		return this.#serversOrigin?.[serverName]?.scope ?? "workspace";
	}
	/**
	* User-scope servers are auto-approved (they live in the user's own config).
	* Workspace- and plugin-scope servers are third-party code and go through the
	* approval gate.
	*/
	#isUserProvidedServer(serverName) {
		return this.#getServerScope(serverName) === "user";
	}
	/**
	* Key a server-approval decision is stored under. Deliberately not
	* `session.currentConfigHash`: that covers the expanded config, which would tie the
	* decision to the current variable values.
	*/
	#getApprovalHash(serverName) {
		const parseResult = this.#serversOrigin?.[serverName]?.parseResult;
		return parseResult?.success ? parseResult.approvalHash : void 0;
	}
	async reloadAllServers(workspacePath) {
		try {
			await this.#doReloadAllServers(workspacePath);
		} finally {
			this.#notifyReloadSettled();
		}
	}
	async #doReloadAllServers(workspacePath) {
		if (workspacePath && workspacePath !== this.#workspacePath) this.#workspacePath = workspacePath;
		if (!this.#workspacePath) {
			this.#logger.warn("[MCP Manager] Cannot reload: no workspace path set");
			return;
		}
		this.#logger.info("[MCP Manager] Reloading all servers from disk");
		const result = await this.#loadConfiguration(this.#workspacePath);
		if (!result) {
			this.#logger.warn("[MCP Manager] No configuration found during reload");
			return;
		}
		this.#serversOrigin = result.serversOrigin;
		for (const [name] of this.#sessions) if (!result.config.mcpServers[name]) {
			this.#logger.debug(`[MCP Manager] Server removed: ${name}`);
			this.#sessions.get(name)?.dispose();
			this.#sessions.delete(name);
			this.#emit("server:disconnected", name, "Server removed from configuration");
		}
		const pendingServerNames = [];
		await Promise.all(Object.entries(result.serversOrigin).map(async ([name, origin]) => {
			const serverName = name;
			const session = this.#sessions.get(serverName);
			if (session) {
				if (!origin.parseResult.success) return;
				const newConfigHash = hashServerConfig(origin.parseResult.config);
				const { approvalHash } = origin.parseResult;
				const configChanged = session.currentConfigHash !== newConfigHash;
				if (this.#isUserProvidedServer(serverName)) await session.applyConfig(origin.parseResult.config);
				else if (configChanged) {
					const approvalEntry = await this.#serverApprovalStore.lookup(approvalHash);
					const effectiveDecision = this.#approvalPolicy.decide(approvalHash, approvalEntry);
					if (effectiveDecision === "approved") await session.applyConfig(origin.parseResult.config);
					else if (effectiveDecision === "rejected") {
						session.applyConfigPendingApproval(origin.parseResult.config);
						session.setRejected();
					} else {
						session.applyConfigPendingApproval(origin.parseResult.config);
						pendingServerNames.push(serverName);
					}
				} else {
					const currentStatus = session.getState().status;
					if (currentStatus === ConnectionState.PendingApproval || currentStatus === ConnectionState.Rejected) {
						const approvalEntry = await this.#serverApprovalStore.lookup(approvalHash);
						const effectiveDecision = this.#approvalPolicy.decide(approvalHash, approvalEntry);
						if (effectiveDecision === "approved") await session.start();
						else if (effectiveDecision === "rejected") session.setRejected();
						else pendingServerNames.push(serverName);
					}
				}
			} else {
				if (!origin.parseResult.success) {
					const newSession = this.#mcpServerSessionManagerFactory.create(serverName, origin.displayName, origin.parseResult.config, this.#workspacePath);
					this.#bindSession(serverName, newSession);
					this.#sessions.set(serverName, newSession);
					return;
				}
				const { approvalHash } = origin.parseResult;
				const newSession = this.#mcpServerSessionManagerFactory.create(serverName, origin.displayName, origin.parseResult.config, this.#workspacePath);
				this.#bindSession(serverName, newSession);
				this.#sessions.set(serverName, newSession);
				if (this.#isUserProvidedServer(serverName)) await newSession.start();
				else {
					const approvalEntry = await this.#serverApprovalStore.lookup(approvalHash);
					const effectiveDecision = this.#approvalPolicy.decide(approvalHash, approvalEntry);
					if (effectiveDecision === "approved") await newSession.start();
					else if (effectiveDecision === "rejected") newSession.setRejected();
					else {
						newSession.setPendingApproval();
						pendingServerNames.push(serverName);
					}
				}
			}
		}));
		if (pendingServerNames.length > 0) {
			this.#logger.info(`[MCP Manager] ${pendingServerNames.length} server(s) pending approval: ${pendingServerNames.join(", ")}`);
			this.#emit("servers:pending-approval", pendingServerNames);
		}
	}
	/**
	* Approve a server by name: persist the decision and start the session.
	*/
	async approveServer(serverName) {
		const session = this.#sessions.get(serverName);
		if (!session) {
			this.#logger.warn(`[MCP Manager] approveServer: server not found: ${serverName}`);
			return;
		}
		const hash = this.#getApprovalHash(serverName);
		if (!hash) {
			this.#logger.warn(`[MCP Manager] approveServer: no config for server: ${serverName}`);
			return;
		}
		await this.#serverApprovalStore.approve(hash);
		this.#logger.info(`[MCP Manager] Server approved: ${serverName}`);
		await session.start();
	}
	/**
	* Reject a server by name: persist the decision and mark the session as rejected.
	*/
	async rejectServer(serverName) {
		const session = this.#sessions.get(serverName);
		if (!session) {
			this.#logger.warn(`[MCP Manager] rejectServer: server not found: ${serverName}`);
			return;
		}
		const hash = this.#getApprovalHash(serverName);
		if (!hash) {
			this.#logger.warn(`[MCP Manager] rejectServer: no config for server: ${serverName}`);
			return;
		}
		await this.#serverApprovalStore.reject(hash);
		this.#logger.info(`[MCP Manager] Server rejected: ${serverName}`);
		session.setRejected();
	}
	/**
	* Revoke a server's approval decision: remove the persisted entry and re-prompt.
	* If the server is currently running, it is stopped and put back into PendingApproval
	* so the user can immediately approve or reject it again without a reload.
	*/
	async revokeServerDecision(serverName) {
		const session = this.#sessions.get(serverName);
		if (!session) {
			this.#logger.warn(`[MCP Manager] revokeServerDecision: server not found: ${serverName}`);
			return;
		}
		const hash = this.#getApprovalHash(serverName);
		if (!hash) {
			this.#logger.warn(`[MCP Manager] revokeServerDecision: no config for server: ${serverName}`);
			return;
		}
		await this.#serverApprovalStore.revoke(hash);
		this.#logger.info(`[MCP Manager] Server decision revoked: ${serverName}`);
		session.setPendingApproval();
	}
	async getTools(workflowId) {
		return (await Promise.all([...this.#sessions.values()].map((s) => s.getTools().map((tools) => this.#transformTools(tools, workflowId)).unwrapOr([])))).flat();
	}
	getToolsForServer(serverName, workflowId) {
		const s = this.#sessions.get(serverName);
		if (!s) return Promise.resolve([]);
		return s.getTools().map((tools) => this.#transformTools(tools, workflowId)).unwrapOr([]);
	}
	executeTool(toolName, args) {
		const startTime = Date.now();
		if (!McpToolName.is(toolName)) throw new Error(`Invalid tool name format: ${toolName}`);
		const address = McpToolName.parse(toolName);
		const s = this.#sessions.get(address.serverName);
		if (!s) throw new Error(`Server not found: ${address.serverName}`);
		this.#logger.debug(`[MCP Manager] Executing tool="${address.toolName}" server="${address.serverName}"`);
		return s.executeTool(address.toolName, args).andTee((result) => {
			this.#executionHistory.push({
				toolName,
				success: true,
				result,
				executedAt: /* @__PURE__ */ new Date()
			});
			this.#addLog(address.serverName, LogLevel.Info, `Tool executed: ${address.toolName}`, { duration: Date.now() - startTime });
		}).orTee((error) => {
			this.#executionHistory.push({
				toolName,
				success: false,
				error: error.message,
				executedAt: /* @__PURE__ */ new Date()
			});
			this.#logger.error(`[MCP Manager] Tool execution failed - tool="${toolName}"`, error);
		}).match((x) => x, (e) => {
			throw new Error(e.message);
		});
	}
	async getExecutionHistory() {
		return [...this.#executionHistory];
	}
	/**
	* Wait for all MCP servers to reach a terminal connection state.
	*
	* A server is considered "settled" when it has reached one of these terminal states:
	* - Connected: Successfully connected and ready to use
	* - Failed: Connection failed or authentication failed
	* - Disconnected: Not connected (initial state or after disconnect)
	*
	* Servers in transient states (Connecting, Authenticating) are not considered settled.
	*
	* This method is typically called after `reloadAllServers()` to ensure servers have
	* completed their connection attempts before retrieving tools or executing workflows.
	*
	* @param timeoutMs - Maximum time to wait in milliseconds (default: 30000ms / 30s)
	* @param options.requireAll - If false (default), resolves when timeout is reached if at least
	*                             one server is connected. If true, rejects on timeout unless ALL
	*                             servers are settled. Use false for graceful degradation.
	*
	* @returns Promise that resolves when settled, or rejects on timeout (if requireAll=true)
	*
	* @throws {Error} When timeout is reached and either no servers are connected (requireAll=false)
	*                 or not all servers are settled (requireAll=true)
	*
	* @remarks
	* - OAuth flows may take significant time (user interaction required), consider longer timeouts
	* - If no servers exist, resolves immediately
	* - Subscribes to 'server:state-changed' events internally, cleans up on completion
	* - With requireAll=false (default), this provides graceful degradation for slow/failing servers
	*/
	async waitForAllServersSettled(timeoutMs = 3e4, options = {}) {
		const { requireAll = false } = options;
		const isSettledState = (state) => {
			return state === ConnectionState.Connected || state === ConnectionState.Disconnected || state === ConnectionState.Failed || state === ConnectionState.PendingApproval || state === ConnectionState.Rejected;
		};
		const checkAllSettled = () => {
			if (this.#sessions.size === 0) return true;
			for (const session of this.#sessions.values()) if (!isSettledState(session.getState().status)) return false;
			return true;
		};
		const hasAnyConnected = () => {
			for (const session of this.#sessions.values()) if (session.getState().status === ConnectionState.Connected) return true;
			return false;
		};
		if (checkAllSettled()) {
			this.#logger.debug("[MCP Manager] All servers already settled");
			return;
		}
		this.#logger.debug(`[MCP Manager] Waiting for servers to settle (timeout=${timeoutMs}ms)`);
		await new Promise((resolve, reject) => {
			let timeout = null;
			const handler = () => {
				if (checkAllSettled()) {
					if (timeout) clearTimeout(timeout);
					this.off("server:state-changed", handler);
					this.#logger.debug("[MCP Manager] All servers settled");
					resolve();
				}
			};
			this.on("server:state-changed", handler);
			timeout = setTimeout(() => {
				this.off("server:state-changed", handler);
				const unsettled = [...this.#sessions.entries()].filter(([, session]) => !isSettledState(session.getState().status)).map(([name]) => name);
				if (!requireAll && hasAnyConnected()) {
					this.#logger.warn(`[MCP Manager] Timeout reached but continuing with ${this.#sessions.size - unsettled.length} settled server(s). Still waiting for: ${unsettled.join(", ")}`);
					resolve();
					return;
				}
				this.#logger.error(`[MCP Manager] Timeout waiting for servers to settle: ${unsettled.join(", ")}`);
				reject(/* @__PURE__ */ new Error(`Timeout after ${timeoutMs}ms waiting for servers to settle. Unsettled servers: ${unsettled.join(", ")}`));
			}, timeoutMs);
		});
	}
	/**
	* Resolve once a reloadAllServers() call has completed.
	*
	* If a reload has already completed at least once, resolves on the next tick.
	* Otherwise waits for the first reload to finish (or the timeout, whichever is
	* first). Unlike waitForAllServersSettled, this never resolves before a reload
	* has actually run, so callers can reliably tell that any pending-approval
	* emission has already fired.
	*/
	whenReloadSettled(timeoutMs = 3e4) {
		if (this.#hasCompletedReload) return Promise.resolve();
		return new Promise((resolve) => {
			let timeout = null;
			const waiter = () => {
				if (timeout) clearTimeout(timeout);
				resolve();
			};
			this.#reloadSettledWaiters.push(waiter);
			timeout = setTimeout(() => {
				const index = this.#reloadSettledWaiters.indexOf(waiter);
				if (index >= 0) this.#reloadSettledWaiters.splice(index, 1);
				this.#logger.warn(`[MCP Manager] whenReloadSettled timed out after ${timeoutMs}ms`);
				resolve();
			}, timeoutMs);
		});
	}
	#notifyReloadSettled() {
		this.#hasCompletedReload = true;
		const waiters = this.#reloadSettledWaiters;
		this.#reloadSettledWaiters = [];
		waiters.forEach((waiter) => waiter());
	}
	async getLogs() {
		return [...this.#logs];
	}
	async getLogsForServer(serverName) {
		return this.#logs.filter((l) => l.serverName === serverName);
	}
	async clearLogsForServer(serverName) {
		this.#logs = this.#logs.filter((l) => l.serverName !== serverName);
	}
	on(event, handler) {
		this.#eventEmitter.on(event, handler);
	}
	off(event, handler) {
		this.#eventEmitter.off(event, handler);
	}
	#bindSession(serverName, session) {
		return session.onStateChanged((state) => this.#onSessionState(serverName, state));
	}
	#onSessionState(serverName, state) {
		this.#emit("server:state-changed", serverName, this.#getServerState(serverName));
		switch (state.status) {
			case ConnectionState.Connected:
				this.#addLog(serverName, LogLevel.Info, "Connected");
				this.#emit("server:connected", serverName, this.#getServerState(serverName));
				this.getToolsForServer(serverName).then((tools) => {
					this.#emit("tools:updated", serverName, tools);
				}).catch((error) => {
					this.#logger.error(`Failed to fetch tools for ${serverName}`, error);
				});
				break;
			case ConnectionState.Authenticating:
				if (state.authUrl) this.#addLog(serverName, LogLevel.Warning, "Authentication required", { authUrl: state.authUrl });
				else this.#addLog(serverName, LogLevel.Warning, "Authentication required");
				break;
			case ConnectionState.Failed:
				this.#addLog(serverName, LogLevel.Error, state.error);
				this.#emit("server:error", serverName, state.error);
				break;
			case ConnectionState.Disconnected:
				this.#addLog(serverName, LogLevel.Info, "Disconnected");
				this.#emit("server:disconnected", serverName, "Disconnected");
				break;
			case ConnectionState.PendingApproval:
				this.#addLog(serverName, LogLevel.Warning, "Pending user approval");
				break;
			case ConnectionState.Rejected:
				this.#addLog(serverName, LogLevel.Warning, "Rejected by user");
				break;
			case ConnectionState.Connecting:
			default: break;
		}
	}
	#getServerState(serverName) {
		const s = this.#sessions.get(serverName);
		if (!s) throw new Error(`Server session not found: ${serverName}`);
		const state = s.getState();
		const connectedAt = state.status === ConnectionState.Connected ? state.connectedAt : void 0;
		const err = state.status === ConnectionState.Failed ? state.error : void 0;
		const authUrl = state.status === ConnectionState.Authenticating ? state.authUrl : void 0;
		const origin = this.#serversOrigin?.[serverName];
		return {
			name: serverName,
			displayName: origin?.displayName ?? serverName,
			config: s.currentConfig || {},
			connectionState: state.status,
			connectedAt,
			error: err,
			authUrl,
			serverInfo: state.status === ConnectionState.Connected ? state.serverInfo : void 0,
			configSource: origin?.resolvedPath,
			scope: this.#getServerScope(serverName)
		};
	}
	#transformTools(tools, workflowId) {
		return tools.map((t) => ({
			...t,
			isApproved: workflowId ? this.#isToolApproved(t.serverName, t.originalToolName, workflowId) : this.#isToolApprovedByConfig(t.serverName, t.originalToolName)
		}));
	}
	#isToolApprovedByConfig(serverName, originalToolName) {
		const origin = this.#serversOrigin?.[serverName];
		if (!origin?.parseResult.success) return false;
		const { approvedTools } = origin.parseResult.config;
		if (approvedTools === true) return true;
		if (Array.isArray(approvedTools)) return approvedTools.includes(originalToolName);
		return false;
	}
	#isToolApproved(serverName, originalToolName, workflowId) {
		const configApproved = this.#isToolApprovedByConfig(serverName, originalToolName);
		const sessionApproved = workflowId ? this.#approvalStore.isToolApproved(workflowId, {
			serverName,
			toolName: originalToolName
		}) : false;
		return configApproved || sessionApproved;
	}
	#emit(event, ...args) {
		this.#eventEmitter.emit(event, ...args);
	}
	#addLog(serverName, level, message, details) {
		const log = {
			id: `log-${++this.#logIdCounter}-${Date.now()}`,
			serverName,
			timestamp: /* @__PURE__ */ new Date(),
			level,
			message,
			details
		};
		this.#logs.unshift(log);
		if (this.#logs.length > 1e3) this.#logs = this.#logs.slice(0, 1e3);
		this.#emit("log:added", log);
		const logFn = levelToMethod[level];
		this.#logger[logFn](`[MCP Manager] ${serverName}: ${message}`);
	}
	async #loadConfiguration(workspacePath) {
		const builtInCandidates = getMcpConfigPathCandidates(workspacePath);
		const providerCandidates = await this.#gatherProviderCandidates(workspacePath);
		const candidates = [...builtInCandidates, ...providerCandidates];
		this.#configSources = candidates;
		const result = await this.#configResolver.loadAndMerge(candidates);
		logMcpConfigResolution(this.#logger, result, candidates.map((c) => c.path));
		if (!result.config) return void 0;
		return {
			config: result.config,
			serversOrigin: result.serversOrigin
		};
	}
	/**
	* Contributed candidates are rebuilt field by field rather than spread, so a
	* provider can only influence what the port exposes — in particular it cannot
	* declare a scope and land its servers in the auto-approved `user` bucket.
	*
	* Candidates without an `id` are dropped rather than loaded unqualified: the id keys
	* their approval decisions, so accepting one without it would let a contributor share
	* another's approval.
	*/
	async #gatherProviderCandidates(workspacePath) {
		return (await Promise.all(this.#configPathProviders.map(async (provider) => {
			try {
				return (await provider.getCandidates(workspacePath)).filter(({ path, id }) => {
					if (id) return true;
					this.#logger.warn(`[MCP Manager] Skipping contributed config without an id: ${path}`);
					return false;
				}).map(({ path, id, variables, namePrefix, displayNamePrefix }) => ({
					path,
					scope: "plugin",
					id,
					variables,
					namePrefix,
					displayNamePrefix
				}));
			} catch (error) {
				this.#logger.warn("[MCP Manager] An MCP config path provider failed; skipping its candidates", error instanceof Error ? error : new Error(String(error)));
				return [];
			}
		}))).flat();
	}
	static {
		_initClass$1();
	}
});
//#endregion
//#region src/mcp/workflow_executor_adaptor.ts
let _initClass;
function _applyDecs(e, t, n, r, o, i) {
	var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length;
	function g(t, n, r) {
		return function(o, i) {
			n && (i = o, o = e);
			for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []);
			return r ? i : o;
		};
	}
	function b(e, t, n, r) {
		if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined"));
		return e;
	}
	function applyDec(e, t, n, r, o, i, u, s, f, l, p) {
		function d(e) {
			if (!p(e)) throw new TypeError("Attempted to access private element on non-instance");
		}
		var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o;
		function I(t, n, r) {
			return function(o, i) {
				return n && (i = o, o = e), r && r(o), P[t].call(o, i);
			};
		}
		if (!w) {
			var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value";
			if (f ? (l || D ? P = {
				get: _setFunctionName(function() {
					return v(this);
				}, r, "get"),
				set: function(e) {
					t[4](this, e);
				}
			} : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) {
				if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet");
				y[+s][r] = o < 3 ? 1 : o;
			}
		}
		for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) {
			var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = {
				kind: [
					"field",
					"accessor",
					"method",
					"getter",
					"setter",
					"class"
				][o],
				name: r,
				metadata: a,
				addInitializer: function(e, t) {
					if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished");
					b(t, "An initializer", "be", !0), i.push(t);
				}.bind(null, A)
			};
			if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);
			else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function(e) {
				return r in e;
			} }, j || (c.get = f ? E ? function(e) {
				return d(e), P.value;
			} : I("get", 0, d) : function(e) {
				return e[r];
			}), E || S || (c.set = f ? I("set", 0, d) : function(e, t) {
				e[r] = t;
			}), N = T.call(z, D ? {
				get: P.get,
				set: P.set
			} : P[F], H), A.v = 1, D) {
				if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);
				else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined");
			} else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N);
		}
		return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N;
	}
	function w(e) {
		return m(e, d, {
			configurable: !0,
			enumerable: !0,
			value: a
		});
	}
	return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function(e) {
		e && f.push(g(e));
	}, p = function(t, r) {
		for (var i = 0; i < n.length; i++) {
			var a = n[i], c = a[1], l = 7 & c;
			if ((8 & c) == t && !l == r) {
				var p = a[2], d = !!a[3], m = 16 & c;
				applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function(t) {
					return _checkInRHS(t) === e;
				} : o);
			}
		}
	}, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), {
		e: c,
		get c() {
			var n = [];
			return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)];
		}
	};
}
function _toPropertyKey(t) {
	var i = _toPrimitive(t, "string");
	return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
	if ("object" != typeof t || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != typeof i) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
function _setFunctionName(e, t, n) {
	"symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : "");
	try {
		Object.defineProperty(e, "name", {
			configurable: !0,
			value: n ? n + " " + t : t
		});
	} catch (e) {}
	return e;
}
function _checkInRHS(e) {
	if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null"));
	return e;
}
const MCP_TOOL_FAILURE_PREFIX = "The tool cannot be executed:";
let _McpManagerWorkflowEx;
(class {
	static {
		[_McpManagerWorkflowEx, _initClass] = _applyDecs(this, [Service({
			dependencies: [Logger, _McpManager],
			lifetime: ServiceLifetime.Singleton
		})], []).c;
	}
	#logger;
	#managerService;
	constructor(logger, managerService) {
		this.#logger = logger;
		this.#managerService = managerService;
	}
	async reload(workspacePath, workflowId) {
		const reloadStart = Date.now();
		try {
			await this.#managerService.reloadAllServers(workspacePath);
			await this.#managerService.waitForAllServersSettled(3e4);
			const tools = await this.#managerService.getTools(workflowId);
			this.#logger.info(`[MCP] Reload complete - tools=${tools.length} duration_ms=${Date.now() - reloadStart}`);
			return tools;
		} catch (e) {
			this.#logger.warn(`[MCP] Error during reload: ${e}`);
			return [];
		}
	}
	preWarm(workspacePath) {
		this.#logger.debug(`[MCP] Pre-warming servers for workspace: ${workspacePath}`);
		this.#managerService.reloadAllServers(workspacePath).catch((e) => {
			this.#logger.warn(`[MCP] Pre-warm failed: ${e}`);
		});
	}
	async execute(name, args) {
		try {
			const parsedArgs = JSON.parse(args);
			return await this.#managerService.executeTool(name, parsedArgs);
		} catch (e) {
			this.#logger.error(`[MCP] Tool execution failed - tool="${name}" error="${e}"`, e);
			return `${MCP_TOOL_FAILURE_PREFIX} ${e}`;
		}
	}
	static {
		_initClass();
	}
});
//#endregion
//#region src/mcp/index.ts
/** LSP notification name for pending MCP server approvals */
const MCP_SERVERS_NEED_APPROVAL_NOTIFICATION = "$/gitlab/mcp/serversNeedApproval";
//#endregion
//#region src/mcp/di.ts
function registerMcpServices(serviceCollection, approvalPolicyClass) {
	registerMcpConfigService(serviceCollection);
	registerMcpAuthServices(serviceCollection);
	registerMcpClientServices(serviceCollection);
	registerMcpApprovalServices(serviceCollection, approvalPolicyClass);
	serviceCollection.addClass(_McpServerSessionMana);
	serviceCollection.addClass(_McpManager);
	serviceCollection.addClass(_McpManagerWorkflowEx);
	return serviceCollection;
}
//#endregion
//#region src/di.ts
function registerAiConfigurationServices(serviceCollection) {
	registerMcpServices(serviceCollection);
	return serviceCollection;
}
//#endregion
export { _AutoApproveApprovalP as AutoApproveApprovalPolicy, ConnectionState, _DefaultApprovalPolic as DefaultApprovalPolicy, LogLevel, MCP_SERVERS_NEED_APPROVAL_NOTIFICATION, MCP_TOOL_FAILURE_PREFIX, McpApprovalPolicy, McpConfigPathProvider, McpConfigWriter, _McpManager as McpManager, _McpManagerWorkflowEx as McpManagerWorkflowExecutorAdaptor, McpServerApprovalStore, McpStdioCommandTransformer, McpToolApprovalController, McpToolName, McpToolSessionApprovalStore, ServerName, WorkflowUrlOpenerService, getDuoConfigDir, getDuoConfigFilePath, getMcpConfigPathCandidates, getTrustedReadableDirectories, isContainedIn, registerAiConfigurationServices, registerMcpServices };

//# sourceMappingURL=index.mjs.map